import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { Field, reduxForm, change } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';
import DatePicker from 'react-datepicker';
import Select2 from 'react-select2-wrapper';
import _, { isEmpty } from 'lodash';
import moment from 'moment-timezone';
import {
  renderField
} from '../../helpers/form-validations';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import Header from '../../components/Header';
import withGoBack from '../../common/withGoBack';
import withOnline from '../../common/withOnline';
import withTeam from '../../common/withTeam';
import withDersDetails from '../../common/withDersDetails';
import withDersFilterResult from '../../common/withDersFilterResult';
import Bugsnag from '../../helpers/bugsnag';
import {
  compactRandomStringMaker, isMobile, isStartsWithNumber, onGoBack, shallowCompare
} from '../../common/globals';
import DerNotSaved from '../../components/Models/DerNotSaved';
import {
  getDersTeamsByTeamName,
  getTableCaseByCaseId,
  getDersByDersNo,
  updateTableWiseCaseByCaseId,
  updateDersById, insertDers, getAllDers
} from '../../utils/db';
import withCaseDer from '../../common/withCaseDer';
import withTableName from '../../common/withTableName';
import withUser from '../../common/withUser';
import { addDersDetails, listSingleCase, updateDers } from '../../utils/utils';
import withViewDersDetails from '../../common/withViewDersDetails';
import withDersProduct from '../../common/withDersProduct';
import withIsShowButtons from '../../common/withIsShowButtons';
import withSelectCaseId from '../../common/withSelectCaseId';
import DersErrorMessage from '../../components/Models/DersErrorMessage';
import ClearDersFields from '../../components/Models/ClearDersFields';
import CopyDers from '../../components/Models/CopyDers';
import withReadCaseData from '../../common/withReadCaseData';
import OptimizeDatePicker from '../../components/commonComponents/OptimizeDatePicker';

class AddNonCaseDer extends Component {
  constructor(props) {
    super(props);
    this.MAX_BROKEN_PRODUCTS = 20;
    this.state = {
      onClickButtonName: '',
      onFocusInputName: '',
      isEditDer: false,
      selectedDateAware: new Date(),
      selectedDateImplanted: '',
      selectedDateExplanted: '',
      patientDob: '',
      patientActivity: [
        'Average', 'Above Average', 'Below Average', 'Highly Active', 'Sedentary', 'Unknown'
      ],
      selectedActivity: '',
      fixCaseData: {},
      investigationDate: '',
      dersTeams: {},
      addNewDers: {
        RepCaseNo: null,
        COMNo: null,
        DeviceType: '',
        DERNotes: null,
        CaseNo: null,
        DERContact: '',
        DERContactPhone: '',
        DERRep: '',
        DERRepPhone: '',
        DERTerritory: '',
        ResponseLetter: 'NO',
        ResponseRecipient: '',
        SurgeonName: '',
        CustomerName: '',
        CustomerNo: '',
        CreditInvoiceNo: '',
        CreditAccountNo: '',
        RepPresent: 'NO',
        DateAware: moment(new Date()).format('YYYY-MM-DD hh:mm:ss.SSS'),
        DateImplanted: '',
        PrimaryCustomerSame: 'YES',
        PrimaryCustomer: '',
        DateExplanted: '',
        PatientName: '',
        PatientAge: '',
        PatientDOB: '',
        PatientGender: 'UNKNOWN',
        PatientHeight: '',
        PatientHeightUnits: 'UNKNOWN',
        PatientWeight: '',
        PatientWeightUnits: 'UNKNOWN',
        PatientStudy: 'UNKNOWN',
        PatientClinicalID: '',
        PatientActivity: '',
        EventInfo: 'DID NOT HAPPEN IN SURGERY',
        XraysAvailable: 'UNKNOWN',
        XraysAvailableReason: '',
        Loosening: 'UNKNOWN',
        LooseningComponents: '',
        LooseningInterface: 'NON-APPLICABLE',
        CementMFR: 'UNKNOWN',
        BrokenRemoved: 'NA',
        ProductDeficiency: 'NO',
        SurgeryExtend: 'UNKNOWN',
        SurgeryExtendTime: '',
        InvestigationRequestor: '',
        InvestigationDate: '',
        InvestigationResponder: '',
        InvestigationResponderTitle: '',
        Xray: '0',
        XrayReason: '',
        Patient: '0',
        PatientReason: '',
        Blood: '0',
        BloodReason: '',
        Histology: '0',
        HistologyReason: '',
        MRI: '0',
        MRIReason: '',
        Ultrasound: '0',
        UltrasoundReason: '',
        Clinical: '0',
        ClinicalReason: '',
        Primary: '0',
        PrimaryReason: '',
        Revision: '0',
        RevisionReason: '',
        Submited: '0',
        products: []
      },
      newDers: {
        RepCaseNo: null,
        COMNo: null,
        DeviceType: null,
        DERNotes: null,
        CaseNo: null,
        DERContact: '',
        DERContactPhone: '',
        DERRep: '',
        DERRepPhone: '',
        DERTerritory: '',
        ResponseLetter: 'NO',
        ResponseRecipient: '',
        SurgeonName: '',
        CustomerName: '',
        CustomerNo: '',
        CreditInvoiceNo: '',
        CreditAccountNo: '',
        RepPresent: 'NO',
        DateAware: moment(new Date()).format('YYYY-MM-DD hh:mm:ss.SSS'),
        DateImplanted: '',
        PrimaryCustomerSame: 'YES',
        PrimaryCustomer: '',
        DateExplanted: '',
        PatientName: '',
        PatientAge: '',
        PatientDOB: '',
        PatientGender: 'UNKNOWN',
        PatientHeight: '',
        PatientHeightUnits: 'UNKNOWN',
        PatientWeight: '',
        PatientWeightUnits: 'UNKNOWN',
        PatientStudy: 'UNKNOWN',
        PatientClinicalID: '',
        PatientActivity: '',
        EventInfo: 'DID NOT HAPPEN IN SURGERY',
        XraysAvailable: 'UNKNOWN',
        XraysAvailableReason: '',
        Loosening: 'UNKNOWN',
        LooseningComponents: '',
        LooseningInterface: 'NON-APPLICABLE',
        CementMFR: 'UNKNOWN',
        BrokenRemoved: 'YES',
        ProductDeficiency: 'NO',
        SurgeryExtend: 'UNKNOWN',
        SurgeryExtendTime: '',
        InvestigationRequestor: '',
        InvestigationDate: '',
        InvestigationResponder: '',
        InvestigationResponderTitle: '',
        Xray: '0',
        XrayReason: '',
        Patient: '0',
        PatientReason: '',
        Blood: '0',
        BloodReason: '',
        Histology: '0',
        HistologyReason: '',
        MRI: '0',
        MRIReason: '',
        Ultrasound: '0',
        UltrasoundReason: '',
        Clinical: '0',
        ClinicalReason: '',
        Primary: '0',
        PrimaryReason: '',
        Revision: '0',
        RevisionReason: '',
        Submited: '0',
        products: []
      },
      errorMessage: '',
      products: {
        ProductCode: '',
        ProductLot: '',
        ProductSide: 'UNKNOWN',
        ProductUsed: 'YES',
        ProductedReturned: 'NO',
        ProductQty: ''
      },
      ProductsBroken: [],
      clearForm: '',
      isCopy: false,
      copyDerNo: null,
      isAddNew: false
    };
    this.derNotSavedModal = null;
    this.dersErrorMessageModal = null;
    this.clearDersFieldsModal = null;
    this.copyDersModal = null;
  }

  async componentDidMount() {
    try {
      document.getElementById('date-picker-input').setAttribute('readonly', 'readonly');
      document.getElementById('date-picker-input1').setAttribute('readonly', 'readonly');
      document.getElementById('date-picker-input2').setAttribute('readonly', 'readonly');
      document.getElementById('date-picker-input3').setAttribute('readonly', 'readonly');
      document.getElementById('date-picker-input4').setAttribute('readonly', 'readonly');

      this.derNotSavedModal = new window.bootstrap.Modal(window.$('#derNotSavedModal'));
      this.dersErrorMessageModal = new window.bootstrap.Modal(window.$('#dersErrorMessageModal'));
      this.clearDersFieldsModal = new window.bootstrap.Modal(window.$('#clearDersFieldsModal'));
      this.copyDersModal = new window.bootstrap.Modal(window.$('#copyDersModal'));
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onEdit = async () => {
    try {
      const { setViewDersDetails, setIsShowButtons } = this.props;
      setIsShowButtons({
        isEdit: true,
        isView: false,
        isCreate: false,
        isCopy: false,
        isSaved: false,
        isSubmitted: false
      });
      setViewDersDetails(false);
      this.setState({ isEditDer: true, isCopy: false });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getFormFieldData = (formData) => {
    try {
      const fields = ['DERContact', 'DERContactPhone', 'DERRep', 'DeviceType', 'DERRepPhone', 'DERNotes',
        'DERTerritory', 'ResponseLetter', 'ResponseRecipient', 'SurgeonName', 'CustomerName', 'CustomerNo',
        'CreditInvoiceNo', 'CreditAccountNo', 'RepPresent', 'DateAware', 'DateImplanted', 'PrimaryCustomerSame',
        'PrimaryCustomer', 'DateExplanted', 'PatientName', 'PatientAge', 'PatientDOB', 'PatientGender',
        'PatientHeight', 'PatientHeightUnits', 'PatientWeight', 'PatientWeightUnits', 'PatientStudy',
        'PatientClinicalID', 'PatientActivity', 'EventInfo', 'XraysAvailable', 'XraysAvailableReason', 'Loosening',
        'LooseningComponents', 'LooseningInterface', 'CementMFR', 'BrokenRemoved', 'ProductDeficiency',
        'SurgeryExtend', 'InvestigationRequestor', 'InvestigationDate', 'InvestigationResponder',
        'InvestigationResponderTitle', 'Xray', 'XrayReason', 'Patient', 'PatientReason', 'Blood', 'BloodReason',
        'Histology', 'HistologyReason', 'MRI', 'MRIReason', 'Ultrasound', 'UltrasoundReason', 'Clinical',
        'ClinicalReason', 'Primary', 'PrimaryReason', 'Revision', 'RevisionReason', 'products'];
      const caseDetail = {};
      fields.map((key) => {
        caseDetail[key] = (!formData.hasOwnProperty(key) || formData[key] === '') ? null : formData[key];
      });
      return caseDetail;
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBackDers = async () => {
    try {
      const {
        params: { caseId }, caseDer, online, goBack
      } = this.props;
      const {
        addNewDers, newDers, selectedDateImplanted, selectedDateExplanted,
        patientDob, selectedActivity, investigationDate, selectedDateAware, isEditDer
      } = this.state;

      // const isPronductEmpty = ProductsBroken.some((item) =>
      // (item.ProductCode === '' || item.ProductLot === ''
      //     || item.ProductQty === ''));

      addNewDers.DateAware = moment(selectedDateAware).format('YYYY-MM-DD');
      addNewDers.DateImplanted = selectedDateImplanted !== '' ? moment(selectedDateImplanted).format('YYYY-MM-DD') : '';
      addNewDers.DateExplanted = selectedDateExplanted !== '' ? moment(selectedDateExplanted).format('YYYY-MM-DD') : '';
      addNewDers.PatientDOB = patientDob !== '' ? moment(patientDob).format('YYYY-MM-DD') : '';
      addNewDers.PatientActivity = selectedActivity;
      addNewDers.InvestigationDate = investigationDate;
      newDers.DateAware = moment(selectedDateAware).format('YYYY-MM-DD');
      newDers.DateImplanted = selectedDateImplanted === '' ? '' : moment(selectedDateImplanted).format('YYYY-MM-DD');
      newDers.DateExplanted = selectedDateExplanted === '' ? '' : moment(selectedDateExplanted).format('YYYY-MM-DD');
      newDers.PatientDOB = patientDob === '' ? '' : moment(patientDob).format('YYYY-MM-DD');
      newDers.InvestigationDate = investigationDate;
      newDers.BloodReason = addNewDers.BloodReason;
      newDers.ClinicalReason = addNewDers.ClinicalReason;
      newDers.CreditAccountNo = addNewDers.CreditAccountNo;
      newDers.CreditInvoiceNo = addNewDers.CreditInvoiceNo;
      newDers.DERRepPhone = addNewDers.DERRepPhone;
      newDers.BrokenRemoved = addNewDers.BrokenRemoved;
      newDers.PatientGender = addNewDers.PatientGender;
      newDers.PatientAge = addNewDers.PatientAge;
      newDers.PatientHeight = addNewDers.PatientHeight;
      newDers.PatientWeight = addNewDers.PatientWeight;
      newDers.EventInfo = addNewDers.EventInfo;
      newDers.PrimaryCustomer = addNewDers.PrimaryCustomer;
      newDers.LooseningComponents = addNewDers.LooseningComponents;
      newDers.HistologyReason = addNewDers.HistologyReason;
      newDers.InvestigationRequestor = addNewDers.InvestigationRequestor;
      newDers.InvestigationResponder = addNewDers.InvestigationResponder;
      newDers.InvestigationResponderTitle = addNewDers.InvestigationResponderTitle;
      newDers.MRIReason = addNewDers.MRIReason;
      newDers.PatientClinicalID = addNewDers.PatientClinicalID;
      newDers.PatientReason = addNewDers.PatientReason;
      newDers.PrimaryReason = addNewDers.PrimaryReason;
      newDers.ResponseRecipient = addNewDers.ResponseRecipient;
      newDers.RevisionReason = addNewDers.RevisionReason;
      newDers.SurgeryExtendTime = addNewDers.SurgeryExtendTime;
      newDers.UltrasoundReason = addNewDers.UltrasoundReason;
      newDers.XrayReason = addNewDers.XrayReason;
      newDers.XraysAvailableReason = addNewDers.XraysAvailableReason;
      // newDers.products = isPronductEmpty ? [] : ProductsBroken;
      newDers.products = addNewDers.products;
      newDers.PatientActivity = selectedActivity;
      newDers.DeviceType = addNewDers.DeviceType;
      newDers.DERNotes = addNewDers.DERNotes;

      if (!online) {
        newDers.DERNo = addNewDers.DERNo;
        newDers.id = addNewDers.id;
        newDers.Sync = addNewDers.Sync;
      }

      if (!isEditDer) {
        onGoBack(goBack);
        return;
      }
      if (caseDer === 'true') {
        if (JSON.stringify(addNewDers) === JSON.stringify(newDers)) {
          onGoBack(goBack);
        } else {
          this.derNotSavedModal.show();
        }
      } else {
        if (isEmpty(caseId)) {
          if (JSON.stringify(addNewDers) === JSON.stringify(newDers)) {
            onGoBack(goBack);
          } else {
            this.derNotSavedModal.show();
          }
        } else {
          const caseRes = await getDersByDersNo(caseId);
          delete caseRes.id;
          delete caseRes.ID;
          caseRes.DateAware = moment(new Date()).format('YYYY-MM-DD');
          const updatedFormData = this._getFormFieldData({ ...addNewDers });
          const fixFormData = this._getFormFieldData(caseRes);
          if (isEditDer === true) {
            if (JSON.stringify(updatedFormData) === JSON.stringify(fixFormData)) {
              onGoBack(goBack);
            } else {
              this.derNotSavedModal.show();
            }
          } else {
            onGoBack(goBack);
          }
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickYes = () => {
    try {
      const { goBack } = this.props;
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getDersTeams = async () => {
    try {
      const { dispatch, user, caseDer } = this.props;
      const { addNewDers, newDers } = this.state;
      const dersTeamsRes = await getDersTeamsByTeamName(user.selectedTeam.name);
      if (dersTeamsRes) {
        this.setState({ dersTeams: dersTeamsRes }, () => {
          dersTeamsRes && Object.keys(dersTeamsRes).map(() => {
            // dispatch(change('AddDersForm', key, dersTeamsRes[key]));
            dispatch(change('AddDersForm', 'DERContact', dersTeamsRes.DERContact));
            dispatch(change('AddDersForm', 'DERContactPhone', dersTeamsRes.DERContactPhone));
            dispatch(change('AddDersForm', 'DERRep', user.name));
            dispatch(change('AddDersForm', 'DERRepPhone', user.phone));
            dispatch(change('AddDersForm', 'DERCRepPhone', dersTeamsRes.DERRepPhone));
            dispatch(change('AddDersForm', 'DERTerritory', dersTeamsRes.DERTerritory));
          });
          addNewDers.DERContact = dersTeamsRes.DERContact;
          addNewDers.DERContactPhone = dersTeamsRes.DERContactPhone;
          addNewDers.DERRep = user.name;
          addNewDers.DERRepPhone = user.phone;
          addNewDers.DERTerritory = dersTeamsRes.DERTerritory;
          addNewDers.EventInfo = (caseDer === 'true' ? '' : addNewDers.EventInfo);
          newDers.DERContact = dersTeamsRes.DERContact;
          newDers.DERContactPhone = dersTeamsRes.DERContactPhone;
          newDers.DERRep = user.name;
          newDers.DERRepPhone = user.phone;
          newDers.DERTerritory = dersTeamsRes.DERTerritory;
          newDers.EventInfo = (caseDer === 'true' ? '' : newDers.EventInfo);
        });
      }
      this.setState({ addNewDers, newDers });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getCaseDerDetails = async () => {
    try {
      const {
        tableName, dispatch, user: { name }, selectCaseId, readCaseData
      } = this.props;
      const {
        CaseNo, SurgeonName, CustomerName, CustomerNo
      } = readCaseData;
      const { addNewDers, dersTeams, newDers } = this.state;
      const caseDetailsRes = await getTableCaseByCaseId(selectCaseId, tableName);
      // console.log(caseDetailsRes);
      this.setState({
        addNewDers: {
          ...addNewDers,
          CaseNo: (typeof CaseNo !== 'undefined' && CaseNo !== null ? CaseNo : null),
          RepCaseNo: caseDetailsRes.RepCaseNo,
          SurgeonName: (typeof SurgeonName !== 'undefined' && SurgeonName !== null ? SurgeonName : (caseDetailsRes.SurgeonName !== '' ? caseDetailsRes.SurgeonName : '')),
          CustomerName: (typeof CustomerName !== 'undefined' && CustomerName !== null ? CustomerName : (caseDetailsRes.CustomerName !== '' ? caseDetailsRes.CustomerName : '')),
          CustomerNo: (typeof CustomerNo !== 'undefined' && CustomerNo !== null ? CustomerNo : (caseDetailsRes.CustomerNo !== '' ? caseDetailsRes.CustomerNo : '')),
          PatientName: '',
          PatientAge: caseDetailsRes.Age,
          PatientWeight: caseDetailsRes.Weight,
          PatientHeight: caseDetailsRes.Height,
        },
        newDers: {
          ...newDers,
          CaseNo: (typeof CaseNo !== 'undefined' && CaseNo !== null ? CaseNo : null),
          RepCaseNo: caseDetailsRes.RepCaseNo,
          SurgeonName: (typeof SurgeonName !== 'undefined' && SurgeonName !== null ? SurgeonName : (caseDetailsRes.SurgeonName !== '' ? caseDetailsRes.SurgeonName : '')),
          CustomerName: (typeof CustomerName !== 'undefined' && CustomerName !== null ? CustomerName : (caseDetailsRes.CustomerName !== '' ? caseDetailsRes.CustomerName : '')),
          CustomerNo: (typeof CustomerNo !== 'undefined' && CustomerNo !== null ? CustomerNo : (caseDetailsRes.CustomerNo !== '' ? caseDetailsRes.CustomerNo : '')),
          PatientName: '',
          PatientAge: caseDetailsRes.Age,
          PatientWeight: caseDetailsRes.Weight,
          PatientHeight: caseDetailsRes.Height,
          DateExplanted: moment(caseDetailsRes.CaseDate).format('YYYY-MM-DD'),
        },
        patientGender: caseDetailsRes.Gender,
        selectedDateExplanted: moment(caseDetailsRes.CaseDate).toDate(),
      }, () => {
        Object.keys(addNewDers).map(() => {
          // dispatch(change('AddDersForm', key, addNewDers[key]));
          dispatch(change('AddDersForm', 'DERContact', dersTeams.DERContact));
          dispatch(change('AddDersForm', 'DERContactPhone', dersTeams.DERContactPhone));
          dispatch(change('AddDersForm', 'DERRep', name));
          dispatch(change('AddDersForm', 'DERCRepPhone', dersTeams.DERRepPhone));
          dispatch(change('AddDersForm', 'DERTerritory', dersTeams.DERTerritory));
          dispatch(change('AddDersForm', 'RepCaseNo', caseDetailsRes.RepCaseNo));
          dispatch(change('AddDersForm', 'CaseNo', (typeof CaseNo !== 'undefined' && CaseNo !== null ? CaseNo : (caseDetailsRes.CaseNo ? caseDetailsRes.CaseNo : (caseDetailsRes.RepCaseNo ? 'PENDING' : '')))));
          dispatch(change('AddDersForm', 'SurgeonName', (typeof SurgeonName !== 'undefined' && SurgeonName !== null ? SurgeonName : (caseDetailsRes.SurgeonName !== '' ? caseDetailsRes.SurgeonName : ''))));
          dispatch(change('AddDersForm', 'CustomerName', (typeof CustomerName !== 'undefined' && CustomerName !== null ? CustomerName : (caseDetailsRes.CustomerName !== '' ? caseDetailsRes.CustomerName : ''))));
          dispatch(change('AddDersForm', 'CustomerNo', (typeof CustomerNo !== 'undefined' && CustomerNo !== null ? CustomerNo : (caseDetailsRes.CustomerNo !== '' ? caseDetailsRes.CustomerNo : ''))));
          dispatch(change('AddDersForm', 'PatientName', ''));
          dispatch(change('AddDersForm', 'PatientAge', caseDetailsRes.Age));
          dispatch(change('AddDersForm', 'PatientWeight', caseDetailsRes.Weight));
          dispatch(change('AddDersForm', 'PatientHeight', caseDetailsRes.Height));
          dispatch(change('AddDersForm', 'DateExplanted', new Date()));
        });
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  fillData = async (data) => {
    try {
      const {
        addNewDers, dersTeams, newDers
      } = this.state;
      // console.log(data);
      const {
        dispatch, user: { name }, setDersProducts, online
      } = this.props;
      const derNoFlag = isStartsWithNumber(data.DERNo);
      this.setState({
        selectedDateAware: new Date(data.DateAware),
        selectedDateImplanted: (isEmpty(data.DateImplanted) || data.DateImplanted === 'Invalid Date') ? '' : new Date(data.DateImplanted),
        selectedDateExplanted: (isEmpty(data.DateExplanted) || data.DateExplanted === 'Invalid Date') ? '' : new Date(data.DateExplanted),
        patientDob: (isEmpty(data.PatientDOB) || data.PatientDOB === 'Invalid Date') ? '' : new Date(data.PatientDOB),
        selectedActivity: data.PatientActivity,
        investigationDate: (isEmpty(data.InvestigationDate) || data.InvestigationDate === 'Invalid Date') ? '' : new Date(data.InvestigationDate),
        ProductsBroken: data.products,
        addNewDers: {
          ...addNewDers,
          RepCaseNo: data.RepCaseNo,
          SurgeonName: data.SurgeonName,
          CustomerName: data.CustomerName,
          CustomerNo: data.CustomerNo,
          PatientName: data.PatientName,
          PatientAge: data.PatientAge,
          RepPresent: data.RepPresent,
          PrimaryCustomer: data.PrimaryCustomer,
          PrimaryCustomerSame: data.PrimaryCustomerSame,
          PatientGender: data.PatientGender,
          ResponseLetter: isEmpty(data.ResponseLetter) ? 'NO' : data.ResponseLetter,
          PatientWeight: data.PatientWeight,
          PatientHeight: data.PatientHeight,
          PatientHeightUnits: isEmpty(data.PatientHeightUnits) ? 'UNKNOWN' : data.PatientHeightUnits,
          PatientWeightUnits: isEmpty(data.PatientWeightUnits) ? 'UNKNOWN' : data.PatientWeightUnits,
          PatientStudy: isEmpty(data.PatientStudy) ? 'UNKNOWN' : data.PatientStudy,
          EventInfo: data.EventInfo,
          XraysAvailable: isEmpty(data.XraysAvailable) ? 'UNKNOWN' : data.XraysAvailable,
          Loosening: isEmpty(data.Loosening) ? 'UNKNOWN' : data.Loosening,
          LooseningComponents: data.LooseningComponents,
          LooseningInterface: isEmpty(data.LooseningInterface) ? 'NON-APPLICABLE' : data.LooseningInterface,
          CementMFR: isEmpty(data.CementMFR) ? 'UNKNOWN' : data.CementMFR,
          BrokenRemoved: isEmpty(data.BrokenRemoved) ? 'NO' : data.BrokenRemoved,
          SurgeryExtend: isEmpty(data.SurgeryExtend) ? 'UNKNOWN' : data.SurgeryExtend,
          ProductDeficiency: isEmpty(data.ProductDeficiency) ? 'NO' : data.ProductDeficiency,
          Xray: isEmpty(data.Xray) ? '0' : data.Xray,
          Patient: isEmpty(data.Patient) ? '0' : data.Patient,
          Blood: isEmpty(data.Blood) ? '0' : data.Blood,
          Histology: isEmpty(data.Histology) ? '0' : data.Histology,
          MRI: isEmpty(data.MRI) ? '0' : data.MRI,
          Ultrasound: isEmpty(data.Ultrasound) ? '0' : data.Ultrasound,
          Clinical: isEmpty(data.Clinical) ? '0' : data.Clinical,
          Primary: isEmpty(data.Primary) ? '0' : data.Primary,
          Revision: isEmpty(data.Revision) ? '0' : data.Revision,
          DERRepPhone: data.DERRepPhone,
          DeviceType: data.DeviceType,
          DERNotes: data.DERNotes,
          Submited: data.Submited
        },
        newDers: {
          ...newDers,
          RepCaseNo: data.RepCaseNo,
          SurgeonName: data.SurgeonName,
          CustomerName: data.CustomerName,
          CustomerNo: data.CustomerNo,
          PatientName: data.PatientName,
          PatientAge: data.PatientAge,
          RepPresent: data.RepPresent,
          PrimaryCustomer: data.PrimaryCustomer,
          PrimaryCustomerSame: data.PrimaryCustomerSame,
          PatientGender: data.PatientGender,
          ResponseLetter: isEmpty(data.ResponseLetter) ? 'NO' : data.ResponseLetter,
          PatientWeight: data.PatientWeight,
          PatientHeight: data.PatientHeight,
          PatientHeightUnits: isEmpty(data.PatientHeightUnits) ? 'UNKNOWN' : data.PatientHeightUnits,
          PatientWeightUnits: isEmpty(data.PatientWeightUnits) ? 'UNKNOWN' : data.PatientWeightUnits,
          PatientStudy: isEmpty(data.PatientStudy) ? 'UNKNOWN' : data.PatientStudy,
          EventInfo: data.EventInfo,
          XraysAvailable: isEmpty(data.XraysAvailable) ? 'UNKNOWN' : data.XraysAvailable,
          Loosening: isEmpty(data.Loosening) ? 'UNKNOWN' : data.Loosening,
          LooseningComponents: data.LooseningComponents,
          LooseningInterface: isEmpty(data.LooseningInterface) ? 'NON-APPLICABLE' : data.LooseningInterface,
          CementMFR: isEmpty(data.CementMFR) ? 'UNKNOWN' : data.CementMFR,
          BrokenRemoved: isEmpty(data.BrokenRemoved) ? 'NO' : data.BrokenRemoved,
          SurgeryExtend: isEmpty(data.SurgeryExtend) ? 'UNKNOWN' : data.SurgeryExtend,
          ProductDeficiency: isEmpty(data.ProductDeficiency) ? 'NO' : data.ProductDeficiency,
          Xray: isEmpty(data.Xray) ? '0' : data.Xray,
          Patient: isEmpty(data.Patient) ? '0' : data.Patient,
          Blood: isEmpty(data.Blood) ? '0' : data.Blood,
          Histology: isEmpty(data.Histology) ? '0' : data.Histology,
          MRI: isEmpty(data.MRI) ? '0' : data.MRI,
          Ultrasound: isEmpty(data.Ultrasound) ? '0' : data.Ultrasound,
          Clinical: isEmpty(data.Clinical) ? '0' : data.Clinical,
          Primary: isEmpty(data.Primary) ? '0' : data.Primary,
          Revision: isEmpty(data.Revision) ? '0' : data.Revision,
          DERRepPhone: data.DERRepPhone,
          DeviceType: data.DeviceType,
          DERNotes: data.DERNotes,
          Submited: data.Submited
        },
      }, () => {
        dispatch(change('AddDersForm', 'DERNo', !online && data.Sync === 1 ? '' : !derNoFlag ? '' : data.DERNo));
        dispatch(change('AddDersForm', 'DERContact', dersTeams.DERContact));
        dispatch(change('AddDersForm', 'DERContactPhone', dersTeams.DERContactPhone));
        dispatch(change('AddDersForm', 'DERRep', name));
        dispatch(change('AddDersForm', 'ResponseRecipient', data.ResponseRecipient));
        dispatch(change('AddDersForm', 'DERRepPhone', data.DERRepPhone));
        dispatch(change('AddDersForm', 'DeviceType', data.DeviceType));
        dispatch(change('AddDersForm', 'DERNotes', data.DERNotes));
        dispatch(change('AddDersForm', 'DERTerritory', dersTeams.DERTerritory));
        dispatch(change('AddDersForm', 'RepCaseNo', data.RepCaseNo));
        dispatch(change('AddDersForm', 'SurgeonName', data.SurgeonName));
        dispatch(change('AddDersForm', 'CustomerName', data.CustomerName));
        dispatch(change('AddDersForm', 'CustomerNo', data.CustomerNo));
        dispatch(change('AddDersForm', 'COMNo', data.COMNo));
        dispatch(change('AddDersForm', 'CaseNo', data.CaseNo
          ? data.CaseNo : data.RepCaseNo ? 'PENDING' : ''));
        dispatch(change('AddDersForm', 'PatientName', data.PatientName));
        dispatch(change('AddDersForm', 'PatientAge', data.PatientAge));
        dispatch(change('AddDersForm', 'PatientHeight', data.PatientHeight));
        dispatch(change('AddDersForm', 'PatientWeight', data.PatientWeight));
        dispatch(change('AddDersForm', 'PatientClinicalID', data.PatientClinicalID));
        dispatch(change('AddDersForm', 'PrimaryCustomer', data.PrimaryCustomer));
        dispatch(change('AddDersForm', 'XrayReason', data.XrayReason));
        dispatch(change('AddDersForm', 'LooseningComponents', data.LooseningComponents));
        dispatch(change('AddDersForm', 'InvestigationRequestor', data.InvestigationRequestor));
        dispatch(change('AddDersForm', 'InvestigationResponder', data.InvestigationResponder));
        dispatch(change('AddDersForm', 'InvestigationResponderTitle', data.InvestigationResponderTitle));
        dispatch(change('AddDersForm', 'PatientReason', data.PatientReason));
        dispatch(change('AddDersForm', 'BloodReason', data.BloodReason));
        dispatch(change('AddDersForm', 'HistologyReason', data.HistologyReason));
        dispatch(change('AddDersForm', 'MRIReason', data.MRIReason));
        dispatch(change('AddDersForm', 'UltrasoundReason', data.UltrasoundReason));
        dispatch(change('AddDersForm', 'ClinicalReason', data.ClinicalReason));
        dispatch(change('AddDersForm', 'PrimaryReason', data.PrimaryReason));
        dispatch(change('AddDersForm', 'RevisionReason', data.RevisionReason));
      });
      const { products } = this.state;
      const arr = [];
      for (let i = 0; i < 20; i++) {
        arr.push(products);
      }
      setDersProducts(arr);
      this.setState({ ProductsBroken: arr }, () => {
        this.state.ProductsBroken.map((item, key) => {
          dispatch(change('AddDersForm', `ProductCode${key}`, ''));
          dispatch(change('AddDersForm', `ProductLot${key}`, ''));
          dispatch(change('AddDersForm', `ProductSide${key}`, 'NO'));
          dispatch(change('AddDersForm', `ProductUsed${key}`, 'NO'));
          dispatch(change('AddDersForm', `ProductedReturned${key}`, 'NO'));
          dispatch(change('AddDersForm', `ProductQty${key}`, ''));
        });
      });
      setDersProducts(data.products);
      this.setState({
        addNewDers: {
          ...this.state.addNewDers,
          products: data.products,
          deviceType: data.DeviceType
        }
      });
      data.products.map((value, key) => {
        dispatch(change('AddDersForm', `ProductCode${key}`, value.ProductCode));
        dispatch(change('AddDersForm', `ProductLot${key}`, value.ProductLot));
        dispatch(change('AddDersForm', `ProductQty${key}`, value.ProductQty));
      });
      this.addProduct();
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  addProduct = () => {
    const {
      dersProducts, setDersProducts, readCaseData, dispatch
    } = this.props;
    const {
      CaseNo, SurgeonName, CustomerName, CustomerNo, RepCaseNo
    } = readCaseData;
    const { products, addNewDers, newDers } = this.state;
    this.setState({
      addNewDers: {
        ...addNewDers,
        CaseNo: (typeof CaseNo !== 'undefined' && CaseNo !== null ? CaseNo : addNewDers.CaseNo),
        SurgeonName: (typeof SurgeonName !== 'undefined' && SurgeonName !== null ? SurgeonName : addNewDers.SurgeonName),
        CustomerName: (typeof CustomerName !== 'undefined' && CustomerName !== null ? CustomerName : addNewDers.CustomerName),
        CustomerNo: (typeof CustomerNo !== 'undefined' && CustomerNo !== null ? CustomerNo : addNewDers.CustomerNo),
      },
      newDers: {
        ...newDers,
        CaseNo: (typeof CaseNo !== 'undefined' && CaseNo !== null ? CaseNo : addNewDers.CaseNo),
        SurgeonName: (typeof SurgeonName !== 'undefined' && SurgeonName !== null ? SurgeonName : addNewDers.SurgeonName),
        CustomerName: (typeof CustomerName !== 'undefined' && CustomerName !== null ? CustomerName : addNewDers.CustomerName),
        CustomerNo: (typeof CustomerNo !== 'undefined' && CustomerNo !== null ? CustomerNo : addNewDers.CustomerNo),
      },
    }, () => {
      Object.keys(addNewDers).map(() => {
        dispatch(change('AddDersForm', 'CaseNo', (typeof CaseNo !== 'undefined' && CaseNo !== null ? CaseNo : (RepCaseNo ? 'PENDING' : addNewDers.CaseNo))));
        dispatch(change('AddDersForm', 'SurgeonName', (typeof SurgeonName !== 'undefined' && SurgeonName !== null ? SurgeonName : addNewDers.SurgeonName)));
        dispatch(change('AddDersForm', 'CustomerName', (typeof CustomerName !== 'undefined' && CustomerName !== null ? CustomerName : addNewDers.CustomerName)));
        dispatch(change('AddDersForm', 'CustomerNo', (typeof CustomerNo !== 'undefined' && CustomerNo !== null ? CustomerNo : addNewDers.CustomerNo)));
      });
    });

    const newProductsBroken = [...dersProducts];
    const lastProduct = newProductsBroken[newProductsBroken.length - 1];
    if (dersProducts.length + 1 < this.MAX_BROKEN_PRODUCTS) {
      if (!lastProduct || !shallowCompare(lastProduct, products)) {
        newProductsBroken.push(products);
      }
    }
    setDersProducts(newProductsBroken);
    this.setState({ ProductsBroken: newProductsBroken });
  }

  _onSubmitDers = async (formData) => {
    try {
      const {
        caseDer,
        user: { name },
        setLoader,
        notify,
        setViewDersDetails,
        tableName,
        selectCaseId,
        setDersFilterResults,
        online,
      } = this.props;
      const {
        addNewDers, patientDob, selectedDateAware, selectedDateImplanted, selectedDateExplanted,
        selectedActivity, investigationDate, ProductsBroken
      } = this.state;

      const productData = ProductsBroken.filter(
        (item) => !isEmpty(item.ProductCode)
          || !isEmpty(item.ProductLot)
          || !isEmpty(item.ProductQty)
      );

      addNewDers.RepCaseNo = !isEmpty(addNewDers.RepCaseNo) ? addNewDers.RepCaseNo : null;
      addNewDers.CaseNo = null;
      addNewDers.COMNo = null;
      addNewDers.DERContact = formData.DERContact;
      addNewDers.DERContactPhone = formData.DERContactPhone;
      addNewDers.DERRep = name;
      addNewDers.DERRepPhone;
      addNewDers.DeviceType = !isEmpty(addNewDers.DeviceType) ? addNewDers.DeviceType : '';
      addNewDers.DERNotes = formData.DERNotes;
      addNewDers.DERTerritory = formData.DERTerritory;
      addNewDers.ResponseLetter;
      addNewDers.ResponseRecipient;
      addNewDers.SurgeonName = !isEmpty(addNewDers.SurgeonName) ? addNewDers.SurgeonName : '';
      addNewDers.CustomerName = !isEmpty(addNewDers.CustomerName) ? addNewDers.CustomerName : '';
      addNewDers.CustomerNo = !isEmpty(addNewDers.CustomerNo) ? addNewDers.CustomerNo : '';
      addNewDers.CreditInvoiceNo;
      addNewDers.CreditAccountNo;
      addNewDers.RepPresent;
      addNewDers.DateAware = moment(selectedDateAware).format('YYYY-MM-DD hh:mm:ss.SSS');
      addNewDers.DateImplanted = selectedDateImplanted !== '' ? moment(selectedDateImplanted).format('YYYY-MM-DD hh:mm:ss.SSS') : '';
      addNewDers.PrimaryCustomerSame;
      addNewDers.PrimaryCustomer = formData.PrimaryCustomer;
      addNewDers.DateExplanted = selectedDateExplanted !== '' ? moment(selectedDateExplanted).format('YYYY-MM-DD') : '';
      addNewDers.PatientName = !isEmpty(addNewDers.PatientName) ? addNewDers.PatientName : '';
      addNewDers.PatientAge;
      addNewDers.PatientDOB = patientDob !== '' ? moment(patientDob).format('YYYY-MM-DD hh:mm:ss.SSS') : '';
      addNewDers.PatientGender;
      addNewDers.PatientHeight;
      addNewDers.PatientHeightUnits;
      addNewDers.PatientWeight;
      addNewDers.PatientWeightUnits;
      addNewDers.PatientStudy;
      addNewDers.PatientClinicalID;
      addNewDers.PatientActivity = selectedActivity;
      addNewDers.EventInfo;
      addNewDers.XraysAvailable;
      addNewDers.XraysAvailableReason;
      addNewDers.Loosening;
      addNewDers.LooseningComponents;
      addNewDers.LooseningInterface;
      addNewDers.CementMFR;
      addNewDers.ProductDeficiency;
      addNewDers.BrokenRemoved;
      addNewDers.SurgeryExtend;
      addNewDers.SurgeryExtendTime;
      addNewDers.InvestigationRequestor;
      addNewDers.InvestigationDate = investigationDate;
      addNewDers.InvestigationResponder;
      addNewDers.InvestigationResponderTitle;
      addNewDers.Xray;
      addNewDers.XrayReason;
      addNewDers.Patient;
      addNewDers.PatientReason;
      addNewDers.Blood;
      addNewDers.BloodReason;
      addNewDers.Histology;
      addNewDers.HistologyReason;
      addNewDers.MRI;
      addNewDers.MRIReason;
      addNewDers.Ultrasound;
      addNewDers.UltrasoundReason;
      addNewDers.Clinical;
      addNewDers.ClinicalReason;
      addNewDers.Primary;
      addNewDers.PrimaryReason;
      addNewDers.Revision;
      addNewDers.RevisionReason;
      addNewDers.products = productData;
      if (caseDer === 'true') {
        // console.log('1');
        if (isEmpty(addNewDers.DeviceType)) {
          this.setState({ errorMessage: 'Please select Device Type' });
          this.dersErrorMessageModal.show();
          return;
        } if (isEmpty(addNewDers.DERContact)) {
          this.setState({ errorMessage: 'Please enter Office Contact', onClickButtonName: 'contactInformation', onFocusInputName: 'DERContact' });
          this.dersErrorMessageModal.show();
          return;
        } if (isEmpty(addNewDers.DERContactPhone)) {
          this.setState({ errorMessage: 'Please enter DER Contact Phone', onClickButtonName: 'contactInformation', onFocusInputName: 'DERContactPhone' });
          this.dersErrorMessageModal.show();
          return;
        } if (isEmpty(addNewDers.DERRep)) {
          this.setState({ errorMessage: 'Please enter Sales Rep', onClickButtonName: 'contactInformation', onFocusInputName: 'DERRep' });
          this.dersErrorMessageModal.show();
          return;
        } if (isEmpty(addNewDers.DERRepPhone)) {
          this.setState({ errorMessage: 'Please enter Rep Phone', onClickButtonName: 'contactInformation', onFocusInputName: 'DERRepPhone' });
          this.dersErrorMessageModal.show();
          return;
        } if (isEmpty(formData.DERTerritory)) {
          this.setState({ errorMessage: 'Please enter Territory', onClickButtonName: 'contactInformation', onFocusInputName: 'DERTerritory' });
          this.dersErrorMessageModal.show();
          return;
        } if (isEmpty(addNewDers.SurgeonName)) {
          this.setState({ errorMessage: 'Please enter Surgeon Name', onClickButtonName: 'hospitalCustomerComplainant', onFocusInputName: 'SurgeonName' });
          this.dersErrorMessageModal.show();
          return;
        } if (isEmpty(addNewDers.CustomerName)) {
          this.setState({ errorMessage: 'Please enter Customer Name', onClickButtonName: 'hospitalCustomerComplainant', onFocusInputName: 'CustomerName' });
          this.dersErrorMessageModal.show();
          return;
        } if (isEmpty(addNewDers.CustomerNo)) {
          this.setState({ errorMessage: 'Please enter Customer No', onClickButtonName: 'hospitalCustomerComplainant', onFocusInputName: 'CustomerNo' });
          this.dersErrorMessageModal.show();
          return;
        } if (selectedDateAware === '') {
          this.setState({ errorMessage: 'Please enter Date Aware' });
          this.dersErrorMessageModal.show();
          return;
        } if (addNewDers.PrimaryCustomerSame === 'NO' && isEmpty(addNewDers.PrimaryCustomer)) {
          this.setState({ errorMessage: 'Please enter Primary Customer', onClickButtonName: 'eventDateInformation', onFocusInputName: 'PrimaryCustomer' });
          this.dersErrorMessageModal.show();
          return;
        } if (isEmpty(addNewDers.BrokenRemoved)) {
          this.setState({ errorMessage: 'Please select All Broken Pices Retrived', onClickButtonName: 'additionalEventInformation' });
          this.dersErrorMessageModal.show();
          return;
        } if (isEmpty(addNewDers.PatientName)) {
          this.setState({ errorMessage: 'Please enter Patient Initials', onClickButtonName: 'patientInformation', onFocusInputName: 'PatientName' });
          this.dersErrorMessageModal.show();
          return;
        }
        // if (isEmpty(addNewDers.PatientAge)) {
        //   this.setState({ errorMessage: 'Please enter Age',
        //   onClickButtonName: 'patientInformation',
        //   onFocusInputName: 'PatientAge' });
        //   this.dersErrorMessageModal.show();
        //   return;
        // } if (patientDob === '') {
        //   this.setState({ errorMessage: 'Please enter DOB',
        //   onClickButtonName: 'patientInformation', onFocusInputName: 'date-picker-input3' });
        //   this.dersErrorMessageModal.show();
        //   return;
        // } if (isEmpty(addNewDers.PatientHeight)) {
        //   this.setState({ errorMessage: 'Please enter Height',
        //   onClickButtonName: 'patientInformation', onFocusInputName: 'PatientHeight' });
        //   this.dersErrorMessageModal.show();
        //   return;
        // } if (isEmpty(addNewDers.PatientWeight)) {
        //   this.setState({ errorMessage: 'Please enter Weight',
        //   onClickButtonName: 'patientInformation', onFocusInputName: 'PatientWeight' });
        //   this.dersErrorMessageModal.show();
        //   return;
        // }
        if (isEmpty(addNewDers.EventInfo)) {
          this.setState({ errorMessage: 'Please enter Event Info', onClickButtonName: 'eventInformation', onFocusInputName: 'EventInfo' });
          this.dersErrorMessageModal.show();
          return;
        } if (addNewDers.XrayAvailable === 'NO' && isEmpty(addNewDers.XraysAvailableReason)) {
          this.setState({ errorMessage: 'Please enter X-rays reason' });
          this.dersErrorMessageModal.show();
          return;
        } if (addNewDers.Loosening === 'YES' && isEmpty(addNewDers.LooseningComponents)) {
          this.setState({ errorMessage: 'Please enter Loosening Components', onClickButtonName: 'additionalEventInformation', onFocusInputName: 'LooseningComponents' });
          this.dersErrorMessageModal.show();
          return;
        } if (addNewDers.SurgeryExtend === 'YES' && isEmpty(addNewDers.SurgeryExtendTime)) {
          this.setState({ errorMessage: 'Please enter Surgery Extend Time.' });
          this.dersErrorMessageModal.show();
          return;
        } if (productData.length === 0) {
          // if (isEmpty(ProductsBroken[0].ProductCode)
          //     && isEmpty(ProductsBroken[0].ProductLot)
          //     && isEmpty(ProductsBroken[0].ProductQty)) {
          this.setState({
            errorMessage: 'Please enter at least one product',
            onClickButtonName: 'productBrokenInformation',
            onFocusInputName: 'ProductCode0'
          });
          this.dersErrorMessageModal.show();
          return;
        } if (ProductsBroken.length > 0) {
          for (let i = 0; i < ProductsBroken.length; i++) {
            if (!isEmpty(ProductsBroken[i].ProductCode)
              || !isEmpty(ProductsBroken[i].ProductLot)
              || !isEmpty(ProductsBroken[i].ProductLot)) {
              if (ProductsBroken[i].ProductCode === '') {
                this.setState({
                  errorMessage: 'Please enter product code',
                  onClickButtonName: 'productBrokenInformation',
                  onFocusInputName: `ProductCode${i}`
                });
                this.dersErrorMessageModal.show();
                return;
              }

              if (ProductsBroken[i].ProductLot === '') {
                this.setState({
                  errorMessage: 'Please enter product lot',
                  onClickButtonName: 'productBrokenInformation',
                  onFocusInputName: `ProductLot${i}`
                });
                this.dersErrorMessageModal.show();
                return;
              }
              if (ProductsBroken[i].ProductQty === '') {
                this.setState({
                  errorMessage: 'Please enter product qty',
                  onClickButtonName: 'productBrokenInformation',
                  onFocusInputName: `ProductQty${i}`
                });
                this.dersErrorMessageModal.show();
                return;
              }
            }
          }
        }
      } else {
        // console.log('2');
        if (isEmpty(addNewDers.DeviceType)) {
          this.setState({ errorMessage: 'Please select Device Type' });
          this.dersErrorMessageModal.show();
          return;
        } if (isEmpty(addNewDers.DERContact)) {
          this.setState({ errorMessage: 'Please enter Office Contact', onClickButtonName: 'contactInformation', onFocusInputName: 'DERContact' });
          this.dersErrorMessageModal.show();
          return;
        } if (isEmpty(addNewDers.DERContactPhone)) {
          this.setState({ errorMessage: 'Please enter DER Contact Phone', onClickButtonName: 'contactInformation', onFocusInputName: 'DERContactPhone' });
          this.dersErrorMessageModal.show();
          return;
        } if (isEmpty(addNewDers.DERRep)) {
          this.setState({ errorMessage: 'Please enter Sales Rep', onClickButtonName: 'contactInformation', onFocusInputName: 'DERRep' });
          this.dersErrorMessageModal.show();
          return;
        } if (isEmpty(addNewDers.DERRepPhone)) {
          this.setState({ errorMessage: 'Please enter Rep Phone', onClickButtonName: 'contactInformation', onFocusInputName: 'DERRepPhone' });
          this.dersErrorMessageModal.show();
          return;
        } if (isEmpty(formData.DERTerritory)) {
          this.setState({ errorMessage: 'Please enter Territory', onClickButtonName: 'contactInformation', onFocusInputName: 'DERTerritory' });
          this.dersErrorMessageModal.show();
          return;
        } if (selectedDateAware === '') {
          this.setState({ errorMessage: 'Please enter Date Aware' });
          this.dersErrorMessageModal.show();
          return;
        } if (isEmpty(addNewDers.EventInfo)) {
          this.setState({ errorMessage: 'Please enter Event Info', onClickButtonName: 'eventInformation', onFocusInputName: 'EventInfo' });
          this.dersErrorMessageModal.show();
          return;
        } if (productData.length === 0) {
          // if (isEmpty(ProductsBroken[0].ProductCode)
          //     && isEmpty(ProductsBroken[0].ProductLot)
          //     && isEmpty(ProductsBroken[0].ProductQty)) {
          this.setState({ errorMessage: 'Please enter at least one product', onClickButtonName: 'productBrokenInformation', onFocusInputName: 'ProductCode0' });
          this.dersErrorMessageModal.show();
          return;
        } if (ProductsBroken.length > 0) {
          for (let i = 0; i < ProductsBroken.length; i++) {
            if (!isEmpty(ProductsBroken[i].ProductCode)
              || !isEmpty(ProductsBroken[i].ProductLot)
              || !isEmpty(ProductsBroken[i].ProductLot)) {
              if (ProductsBroken[i].ProductCode === '') {
                this.setState({
                  errorMessage: 'Please enter product code',
                  onClickButtonName: 'productBrokenInformation',
                  onFocusInputName: `ProductCode${i}`
                });
                this.dersErrorMessageModal.show();
                return;
              }

              if (ProductsBroken[i].ProductLot === '') {
                this.setState({
                  errorMessage: 'Please enter product lot',
                  onClickButtonName: 'productBrokenInformation',
                  onFocusInputName: `ProductLot${i}`
                });
                this.dersErrorMessageModal.show();
                return;
              }
              if (ProductsBroken[i].ProductQty === '') {
                this.setState({
                  errorMessage: 'Please enter product qty',
                  onClickButtonName: 'productBrokenInformation',
                  onFocusInputName: `ProductQty${i}`
                });
                this.dersErrorMessageModal.show();
                return;
              }
            }
          }
        }
      }
      addNewDers.Submited = formData.isSave ? '0' : '1';
      // console.log(addNewDers);
      if (online) {
        let responseJson = {};
        const { params } = this.props;
        if (caseDer === 'true') {
          const caseDetailsRes = await getTableCaseByCaseId(selectCaseId, tableName);
          addNewDers.CaseNo = caseDetailsRes.CaseNo;
        }
        setLoader(true);
        if (isEmpty(params.caseId)) {
          responseJson = await addDersDetails(addNewDers);
        } else {
          responseJson = await updateDers(params.caseId, addNewDers);
        }
        const { message, status, data } = responseJson;
        if (status) {
          if (caseDer === 'true') {
            // find case and store der response
            const caseDetailsRes = await getTableCaseByCaseId(selectCaseId, tableName);
            const caseRes = await listSingleCase(caseDetailsRes.CaseScheduleID);
            if (!isEmpty(params.caseId)) {
              const caseDersData = caseRes.data[0].case_ders;
              caseDetailsRes.case_ders = caseDersData;
              const dersData = await getDersByDersNo(data.DERNo);
              await updateDersById(dersData.id, { ...data, id: dersData.id });
              await updateTableWiseCaseByCaseId(
                caseDetailsRes.RepCaseNo, caseDetailsRes, tableName
              );
              await this.fillData(data);
            } else {
              const caseDers = (typeof caseDetailsRes.case_ders !== 'undefined' ? caseDetailsRes.case_ders : []);
              caseDers.push(data);
              caseDetailsRes.case_ders = caseDers;
              await insertDers(data);
              await this.fillData(data);
              await updateTableWiseCaseByCaseId(
                caseDetailsRes.RepCaseNo, caseDetailsRes, tableName
              );
              this.setState({ isEditDer: false });
              browserHistory.push(`/ders/der/${data.DERNo}`);
            }
          } else {
            // local add/edit ders
            if (!isEmpty(params.caseId)) {
              const dersData = await getDersByDersNo(data.DERNo);
              await updateDersById(dersData.id, { ...data, id: dersData.id });
              const dersList = await getAllDers();
              setDersFilterResults(dersList);
              await this.fillData(data);
            } else {
              await insertDers(data);
              this.setState({ isEditDer: false });
              browserHistory.push(`/ders/der/${data.DERNo}`);
              await this.fillData(data);
            }
          }
          if (formData.isSave) {
            setViewDersDetails(true);
            this.setState({ isCopy: true, isAddNew: true, isEditDer: false });
          }
          const { setIsShowButtons, viewDersDetails } = this.props;
          setIsShowButtons({
            isView: true,
            isEdit: false,
            isCreate: false,
            isCopy: false,
            isSaved: formData.isSave ? true : !viewDersDetails,
            // isSaved: !viewDersDetails,
            isSubmitted: false
          });
          setLoader(false);
        } else {
          notify({ type: 'error', message });
          setLoader(false);
        }
      } else {
        if (addNewDers.Submited === '1') {
          notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 2 });
          this.setState({ addNewDers: { ...addNewDers, Submited: '0' } });
          return;
        }

        const { params: { caseId } } = this.props;
        if (caseDer === 'true') {
          setLoader(true);
          const caseDetailsRes = await getTableCaseByCaseId(selectCaseId, tableName);
          if (!isEmpty(caseId)) {
            const caseDersRes = caseDetailsRes.case_ders;
            const filtered = caseDersRes.filter((el) => el.DERNo !== caseId);
            addNewDers.DERNo = caseId;
            filtered.push(addNewDers);
            caseDetailsRes.case_ders = filtered;
            caseDetailsRes.Sync = 1;
            await updateTableWiseCaseByCaseId(
              caseDetailsRes.RepCaseNo, caseDetailsRes, tableName
            );
          } else {
            const DERNo = compactRandomStringMaker(5);
            // const DERNo = (Math.random() + 1).toString(36).substring(7);
            const caseDers = caseDetailsRes.case_ders;
            addNewDers.DERNo = DERNo;
            addNewDers.Sync = 1;
            caseDers.push(addNewDers);
            caseDetailsRes.case_ders = caseDers;
            caseDetailsRes.Sync = 1;
            await insertDers(addNewDers);
            this.setState({ isEditDer: false });
            browserHistory.push(`/ders/der/${addNewDers.DERNo}`);
            await updateTableWiseCaseByCaseId(
              caseDetailsRes.RepCaseNo, caseDetailsRes, tableName
            );
          }
          if (formData.isSave) {
            setViewDersDetails(true);
            this.setState({ isCopy: true, isAddNew: true, isEditDer: false });
          }
          const { setIsShowButtons, viewDersDetails } = this.props;
          setIsShowButtons({
            isView: true,
            isEdit: false,
            isCreate: false,
            isCopy: false,
            isSaved: formData.isSave ? true : !viewDersDetails,
            isSubmitted: false
          });
          setLoader(false);
        } else {
          notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 2 });
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onChangeEventInfo = (key, value) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, EventInfo: value } });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  updateProducts = async () => {
    try {
      const {
        dersProducts, setDersProducts
      } = this.props;
      const { products } = this.state;
      const productData = [];
      dersProducts.push(products);
      dersProducts.map((item) => {
        productData.push(Object.assign(item));
      });
      this.setState({ ProductsBroken: dersProducts });
      setDersProducts(dersProducts);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  /* _onClickAddProduct = async () => {
    try {
      const { ProductsBroken } = this.state;
      const { setDersProducts } = this.props;
      ProductsBroken.push({
        ProductCode: '',
        ProductLot: '',
        ProductSide: 'UNKNOWN',
        ProductUsed: 'YES',
        ProductedReturned: 'NO',
        ProductQty: ''
      });
      setDersProducts(ProductsBroken);
      this.setState({ ProductsBroken });
    } catch (e) {
      Bugsnag.notify(e);

    }
  } */

  _updateProductState = async (key) => {
    try {
      const { dersProducts } = this.props;
      const { products, addNewDers } = this.state;
      const {
        ProductCode, ProductLot, ProductSide,
        ProductUsed, ProductedReturned, ProductQty
      } = products;
      if (Object.keys(products).length > 0) {
        dersProducts[key] = Object.assign(dersProducts[key],
          {
            ProductCode,
            ProductLot,
            ProductSide,
            ProductUsed,
            ProductedReturned,
            ProductQty
          });
        this.setState({
          addNewDers: { ...addNewDers, products: dersProducts },
          ProductsBroken: dersProducts,
          products: {
            ProductCode: '',
            ProductLot: '',
            ProductSide: 'UNKNOWN',
            ProductUsed: 'YES',
            ProductedReturned: 'NO',
            ProductQty: ''
          }
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onDeviceType = (value) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, DeviceType: value } });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onResponseLetter = (value) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, ResponseLetter: value } });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onRepPresent = (value) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, RepPresent: value } });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onPrimaryCustomerSame = (value) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, PrimaryCustomerSame: value } });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onPatientGender = (value) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, PatientGender: value } });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onPatientHeightUnits = (value) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, PatientHeightUnits: value } });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onPatientWeightUnits = (value) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, PatientWeightUnits: value } });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onPatientStudy = (value) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, PatientStudy: value } });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onXraysAvailable = (value) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, XraysAvailable: value } });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onLooseing = (value) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, Loosening: value } });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onLooseningInterface = (value) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, LooseningInterface: value } });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onCementMfr = (value) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, CementMFR: value } });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onProductDeficiency = (value) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, ProductDeficiency: value } });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onBrokenRemoved = (value) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, BrokenRemoved: value } });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onSurgeryExtend = (value) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, SurgeryExtend: value } });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onXray = (value) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, Xray: value } });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onPatient = (value) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, Patient: value } });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onBlood = (value) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, Blood: value } });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onHistology = (value) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, Histology: value } });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onMri = (value) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, MRI: value } });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onUltraSound = (value) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, Ultrasound: value } });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onClinical = (value) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, Clinical: value } });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onPrimary = (value) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, Primary: value } });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onRevision = (value) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, Revision: value } });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onChangeDerRepPhone = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, DERRepPhone: e.target.value } });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangeDerTerritory = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, DERTerritory: e.target.value } });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangeDerContact = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, DERContact: e.target.value } });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangeDerContactPhone = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, DERContactPhone: e.target.value } });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangeDerRep = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, DERRep: e.target.value } });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangeResponseRecipient = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, ResponseRecipient: e.target.value } }, () => {
        // this._updatePreferenceState();
      });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangeSurgeonName = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, SurgeonName: e.target.value } });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangeCustomerName = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, CustomerName: e.target.value } }, () => {
        // this._updatePreferenceState();
      });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangeCustomerNo = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, CustomerNo: e.target.value } }, () => {
        // this._updatePreferenceState();
      });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangeCreditInvoiceNo = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, CreditInvoiceNo: e.target.value } });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangeCreditAccountNo = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, CreditAccountNo: e.target.value } });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangePrimaryCustomer = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, PrimaryCustomer: e.target.value } });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangePatientName = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, PatientName: e.target.value } });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangePatientAge = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, PatientAge: e.target.value } }, () => {
        // this._updatePreferenceState();
      });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangePatientHeight = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, PatientHeight: e.target.value } }, () => {
        // this._updatePreferenceState();
      });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangePatientWeight = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, PatientWeight: e.target.value } });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangePatientClinicalID = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, PatientClinicalID: e.target.value } });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangeXraysAvailableReason = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, XraysAvailableReason: e.target.value } }, () => {
        // this._updatePreferenceState();
      });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangeLooseningComponents = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, LooseningComponents: e.target.value } });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangeSurgeryExtendTime = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, SurgeryExtendTime: e.target.value } });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangeProductCode = (e, key) => {
    try {
      const { dersProducts, dispatch } = this.props;
      if (!dersProducts[key].ProductQty) {
        dispatch(change('AddDersForm', `ProductQty${key}`, '1'));
      }
      const productName = e.target.value;
      if (productName.trim() === '') {
        dispatch(change('AddDersForm', `ProductQty${key}`, ''));
      }

      const updateProduct = dersProducts.map(
        (product, ind) => (ind === key ? {
          ...product,
          ProductCode: e.target.value,
          ProductQty: (productName.trim() === '' ? '' : (!product.ProductQty ? '1' : product.ProductQty))
        } : product)
      );
      this._setProductsBroken(updateProduct);
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _setProductsBroken = (newProductsBroken) => {
    const { setDersProducts } = this.props;
    const { products } = this.state;
    const updatedProductsBroken = [...newProductsBroken];
    const lastProduct = newProductsBroken.pop();
    if (newProductsBroken.length + 1 < this.MAX_BROKEN_PRODUCTS
      && !shallowCompare(lastProduct, products)) {
      updatedProductsBroken.push(products);
    }
    setDersProducts(updatedProductsBroken);
    this.setState({ ProductsBroken: updatedProductsBroken });
  }

  _onChangeProductLot = (e, key) => {
    try {
      const { dersProducts } = this.props;
      const updateProduct = dersProducts.map(
        (product, ind) => (ind === key ? { ...product, ProductLot: e.target.value } : product)
      );
      this._setProductsBroken(updateProduct);
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onProductSide = (value, key) => {
    try {
      const { dersProducts } = this.props;
      const updateProduct = dersProducts.map(
        (product, ind) => (ind === key ? { ...product, ProductSide: value } : product)
      );
      this._setProductsBroken(updateProduct);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onProductUsed = (value, key) => {
    try {
      const { dersProducts } = this.props;
      const updateProduct = dersProducts.map(
        (product, ind) => (ind === key ? { ...product, ProductUsed: value } : product)
      );
      this._setProductsBroken(updateProduct);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onProductReturned = (value, key) => {
    try {
      const { dersProducts } = this.props;
      const updateProduct = dersProducts.map(
        (product, ind) => (ind === key ? { ...product, ProductedReturned: value } : product)
      );
      this._setProductsBroken(updateProduct);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onChangeProductQty = (e, key) => {
    try {
      const { dersProducts } = this.props;
      const updateProduct = dersProducts.map(
        (product, ind) => (ind === key ? { ...product, ProductQty: e.target.value } : product)
      );
      this._setProductsBroken(updateProduct);
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangeInvestigationRequestor = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({
        addNewDers: {
          ...addNewDers,
          InvestigationRequestor: e.target.value
        }
      });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangeDerNotes = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({
        addNewDers: {
          ...addNewDers,
          DERNotes: e.target.value
        }
      });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangeInvestigationResponder = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({
        addNewDers: {
          ...addNewDers,
          InvestigationResponder: e.target.value
        }
      });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangeInvestigationResponderTitle = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({
        addNewDers: {
          ...addNewDers,
          InvestigationResponderTitle: e.target.value
        }
      });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangeXrayReason = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, XrayReason: e.target.value } });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangePatientReason = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, PatientReason: e.target.value } });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangeBloodReason = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, BloodReason: e.target.value } });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangeHistologyReason = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, HistologyReason: e.target.value } });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangeMriReason = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, MRIReason: e.target.value } });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangeUltraSoundReason = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, UltrasoundReason: e.target.value } });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangeClinicalReason = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, ClinicalReason: e.target.value } });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangePrimaryReason = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, PrimaryReason: e.target.value } });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onChangeRevisionReason = (e) => {
    try {
      const { addNewDers } = this.state;
      this.setState({ addNewDers: { ...addNewDers, RevisionReason: e.target.value } });
    } catch (err) {
      Bugsnag.notify(err);
    }
  }

  _onClearDersFormFields = (value) => {
    try {
      this.clearDersFieldsModal.show();
      this.setState({
        clearForm: value
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickYesClear = async (value) => {
    try {
      const { dispatch } = this.props;
      const { addNewDers } = this.state;
      if (value === 'contactInformation') {
        addNewDers.DERContact = '';
        addNewDers.DERContactPhone = '';
        addNewDers.DERRepPhone = '';
        addNewDers.DERTerritory = '';
        addNewDers.ResponseLetter = 'NO';
        addNewDers.ResponseRecipient = '';
        dispatch(change('AddDersForm', 'DERContact', ''));
        dispatch(change('AddDersForm', 'DERContactPhone', ''));
        dispatch(change('AddDersForm', 'DERRepPhone', ''));
        dispatch(change('AddDersForm', 'DERTerritory', ''));
        dispatch(change('AddDersForm', 'ResponseLetter', 'NO'));
        dispatch(change('AddDersForm', 'ResponseRecipient', ''));
      } else if (value === 'hospital') {
        addNewDers.SurgeonName = '';
        addNewDers.CustomerName = '';
        addNewDers.CustomerNo = '';
        addNewDers.CreditInvoiceNo = '';
        addNewDers.CreditAccountNo = '';
        dispatch(change('AddDersForm', 'SurgeonName', ''));
        dispatch(change('AddDersForm', 'CustomerName', ''));
        dispatch(change('AddDersForm', 'CustomerNo', ''));
        dispatch(change('AddDersForm', 'CreditInvoiceNo', ''));
        dispatch(change('AddDersForm', 'CreditAccountNo', ''));
      } else if (value === 'eventDate') {
        addNewDers.RepPresent = 'NO';
        addNewDers.DateAware = '';
        addNewDers.DateImplanted = '';
        addNewDers.PrimaryCustomerSame = 'NO';
        addNewDers.PrimaryCustomer = '';
        addNewDers.DateExplanted = '';
        dispatch(change('AddDersForm', 'PrimaryCustomer', ''));
        this.setState({
          selectedDateAware: '',
          selectedDateImplanted: '',
          selectedDateExplanted: ''
        });
      } else if (value === 'patient') {
        addNewDers.PatientName = '';
        addNewDers.PatientAge = '';
        addNewDers.PatientDOB = '';
        addNewDers.PatientGender = 'NO INFORMATION';
        addNewDers.PatientHeight = '';
        addNewDers.PatientHeightUnits = 'UNKNOWN';
        addNewDers.PatientWeight = '';
        addNewDers.PatientWeightUnits = 'UNKNOWN';
        addNewDers.PatientStudy = 'UNKNOWN';
        addNewDers.PatientClinicalID = '';
        addNewDers.PatientActivity = '';
        dispatch(change('AddDersForm', 'PatientName', ''));
        dispatch(change('AddDersForm', 'PatientAge', ''));
        dispatch(change('AddDersForm', 'PatientHeight', ''));
        dispatch(change('AddDersForm', 'PatientWeight', ''));
        dispatch(change('AddDersForm', 'PatientClinicalID', ''));
        dispatch(change('AddDersForm', 'PatientActivity', ''));
        this.setState({
          patientDob: '',
          selectedActivity: ''
        });
      } else if (value === 'event') {
        addNewDers.EventInfo = '';
        dispatch(change('AddDersForm', 'EventInfo', ''));
      } else if (value === 'additionalEvent') {
        addNewDers.XraysAvailable = 'UNKNOWN';
        addNewDers.XraysAvailableReason = '';
        addNewDers.Loosening = 'UNKNOWN';
        addNewDers.LooseningComponents = '';
        addNewDers.LooseningInterface = 'NON-APPLICABLE';
        addNewDers.CementMFR = 'UNKNOWN';
        addNewDers.BrokenRemoved = 'UNKNOWN';
        addNewDers.SurgeryExtend = 'UNKNOWN';
        addNewDers.ProductDeficiency = 'NO';
        dispatch(change('AddDersForm', 'XraysAvailableReason', ''));
        dispatch(change('AddDersForm', 'LooseningComponents', ''));
      } else if (value === 'investigation') {
        addNewDers.InvestigationRequestor = '';
        addNewDers.InvestigationResponder = '';
        addNewDers.InvestigationResponderTitle = '';
        addNewDers.Xray = '0';
        addNewDers.XrayReason = '';
        addNewDers.Patient = '0';
        addNewDers.PatientReason = '';
        addNewDers.Blood = '0';
        addNewDers.BloodReason = '';
        addNewDers.Histology = '0';
        addNewDers.HistologyReason = '';
        addNewDers.MRI = '0';
        addNewDers.MRIReason = '';
        addNewDers.Ultrasound = '0';
        addNewDers.UltrasoundReason = '';
        addNewDers.Clinical = '0';
        addNewDers.ClinicalReason = '';
        addNewDers.Primary = '0';
        addNewDers.PrimaryReason = '';
        addNewDers.Revision = '0';
        addNewDers.RevisionReason = '';
        dispatch(change('AddDersForm', 'InvestigationRequestor', ''));
        dispatch(change('AddDersForm', 'InvestigationResponder', ''));
        dispatch(change('AddDersForm', 'InvestigationResponderTitle', ''));
        dispatch(change('AddDersForm', 'XrayReason', ''));
        dispatch(change('AddDersForm', 'PatientReason', ''));
        dispatch(change('AddDersForm', 'BloodReason', ''));
        dispatch(change('AddDersForm', 'HistologyReason', ''));
        dispatch(change('AddDersForm', 'MRIReason', ''));
        dispatch(change('AddDersForm', 'UltrasoundReason', ''));
        dispatch(change('AddDersForm', 'ClinicalReason', ''));
        dispatch(change('AddDersForm', 'PrimaryReason', ''));
        dispatch(change('AddDersForm', 'RevisionReason', ''));
        this.setState({ investigationDate: '' });
      } else if (value === 'products') {
        const { setDersProducts } = this.props;
        const { products } = this.state;
        const arr = [];
        for (let i = 0; i < 20; i++) {
          arr.push(products);
        }
        setDersProducts(arr);
        this.setState({ ProductsBroken: arr }, () => {
          this.state.ProductsBroken.map((item, key) => {
            dispatch(change('AddDersForm', `ProductCode${key}`, ''));
            dispatch(change('AddDersForm', `ProductLot${key}`, ''));
            dispatch(change('AddDersForm', `ProductSide${key}`, 'NO'));
            dispatch(change('AddDersForm', `ProductUsed${key}`, 'NO'));
            dispatch(change('AddDersForm', `ProductedReturned${key}`, 'NO'));
            dispatch(change('AddDersForm', `ProductQty${key}`, ''));
          });
        });

        /* setDersProducts([]);
        ProductsBroken.map((item, key) => {
          dispatch(change('AddDersForm', `ProductCode${key}`, ''));
          dispatch(change('AddDersForm', `ProductLot${key}`, ''));
          dispatch(change('AddDersForm', `ProductSide${key}`, 'NO'));
          dispatch(change('AddDersForm', `ProductUsed${key}`, 'NO'));
          dispatch(change('AddDersForm', `ProductedReturned${key}`, 'NO'));
          dispatch(change('AddDersForm', `ProductQty${key}`, ''));
        });
        this.setState({
          ProductsBroken: [],
          products: {
            ProductCode: '',
            ProductLot: '',
            ProductSide: 'UNKNOWN',
            ProductUsed: 'YES',
            ProductedReturned: 'NO',
            ProductQty: ''
          },
        }, () => {
          this._onClickAddProduct();
        }); */
      } else if (value === 'derEmailNotes') {
        dispatch(change('AddDersForm', 'DERNotes', ''));
      }
      this.setState({ addNewDers });
      this.clearDersFieldsModal.hide();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCopyDer = async () => {
    try {
      this.copyDersModal.show();
      const { setViewDersDetails, params: { caseId }, setIsShowButtons } = this.props;
      const dersRes = await getDersByDersNo(caseId);
      dersRes.DERNo = null;
      dersRes.Submited = '0';
      await this.fillData(dersRes);
      setViewDersDetails(false);
      setIsShowButtons({
        isView: false,
        isEdit: false,
        isCreate: false,
        isCopy: true,
        isSaved: false,
        isSubmitted: false
      });
      this.setState({ copyDerNo: caseId, isEditDer: true, isCopy: true });
      browserHistory.push('/ders/add-der');
      // browserHistory.push('/ders/add-non-case-der');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  onPressOkay = () => {
    const {
      onClickButtonName, onFocusInputName
    } = this.state;
    const isAreaExpand = window.$(`#${onClickButtonName}`).attr('aria-expanded');
    if (isAreaExpand === 'false') {
      window.$(`#${onClickButtonName}`).click();
    }
    window.$(`#${onFocusInputName}`).focus();
  }

  async UNSAFE_componentWillMount() {
    try {
      const {
        caseDer, params: { caseId }, setLoader
      } = this.props;
      setLoader(true);
      await this._getDersTeams();
      // await this.updateProducts();
      if (caseDer === 'true') {
        if (isEmpty(caseId)) {
          // console.log('11');
          await this._getCaseDerDetails();
        }
      }
      if (!isEmpty(caseId)) {
        // console.log('12');
        const caseRes = await getDersByDersNo(caseId);
        await this.fillData(caseRes);
      } else {
        // console.log('13');
        this.addProduct();
      }
      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const {
      handleSubmit, caseDer, viewDersDetails, isShowButtons
    } = this.props;

    const {
      isEditDer, selectedDateAware, selectedDateImplanted, selectedDateExplanted, patientDob,
      patientActivity, selectedActivity, investigationDate, dersTeams, addNewDers,
      errorMessage, ProductsBroken, clearForm, copyDerNo
    } = this.state;

    return (
      <form name="AddDersForm" className="der-section resizer-class">
        <Header
          actionButton={(isShowButtons.isView && addNewDers.Submited === '0') ? { title: 'Edit', onClick: this._onEdit } : ''}
          title={(isShowButtons.isEdit && addNewDers.Submited === '0') ? 'Edit DER'
            : (isShowButtons.isCopy) ? 'Copy DER'
              : (isShowButtons.isCreate) ? 'Create DER'
                : 'View DER'}
          goBack={this._onGoBackDers}
        />
        <section className="billing-section manage-session pt-0">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="der-top-block">
                  <table className="table der-table table-dark table-bordered mb-0">
                    <tr>
                      <th>DER #</th>
                      <td>
                        <Field
                          type="text"
                          name="DERNo"
                          style={{ background: '#212121' }}
                          className="form-control"
                          component={renderField}
                          disabled
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>CASE #</th>
                      <td>
                        <Field
                          type="text"
                          name="CaseNo"
                          style={{ background: '#212121' }}
                          className="form-control"
                          component={renderField}
                          disabled
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>PC #</th>
                      <td>
                        <Field
                          type="text"
                          name="COMNo"
                          style={{ background: '#212121' }}
                          className="form-control"
                          component={renderField}
                          disabled
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>Device Type</th>
                      <td>
                        <div className="p-0">
                          <div className="form-check form-check-inline mb-0">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="DeviceType"
                              id="deviceTypeImplant" value="Implant"
                              checked={addNewDers.DeviceType && addNewDers.DeviceType.toUpperCase() === 'Implant'.toUpperCase()}
                              onChange={() => this._onDeviceType('Implant')}
                            />
                            <label
                              className="form-check-label cursor-pointer"
                              htmlFor="deviceTypeImplant"
                            >Implant
                            </label>
                          </div>
                          <div className="form-check form-check-inline mb-0">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="DeviceType"
                              id="deviceTypeInstrument" value="Instrument"
                              checked={addNewDers.DeviceType && addNewDers.DeviceType.toUpperCase() === 'Instrument'.toUpperCase()}
                              onChange={() => this._onDeviceType('Instrument')}
                            />
                            <label
                              className="form-check-label cursor-pointer"
                              htmlFor="deviceTypeInstrument"
                            >Instrument
                            </label>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <div className="col-12">
                <div className="accordion accordion-dark" id="accordionDRE">
                  <div className="accordion-item accordionItem" style={{ marginBottom: 4 }}>
                    <div className="accordion-header collapsed" id="headingOne">
                      <button
                        id="contactInformation"
                        className="accordion-button" type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne" aria-expanded="false"
                        aria-controls="collapseOne"
                      >
                        Contact information
                      </button>
                      <button
                        type="button" className="btn btn-cross"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne" aria-expanded="false"
                        aria-controls="collapseOne"
                      >
                        <i
                          className="fa fa-times-circle"
                          onClick={isEditDer === false && viewDersDetails === true ? () => { } : () => this._onClearDersFormFields('contactInformation')}
                        />
                      </button>
                    </div>
                    <div
                      id="collapseOne" className="accordion-collapse collapse"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionDRE"
                    >
                      <div className="accordion-body">
                        {
                          !_.isEmpty(dersTeams) && (
                            <table className="table der-table table-dark table-bordered mb-0">
                              <tr>
                                <th>Office Contact</th>
                                <td>
                                  <Field
                                    type="text"
                                    name="DERContact"
                                    id="DERContact"
                                    className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                    component={renderField}
                                    onChange={this._onChangeDerContact}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <th>Contact Phone</th>
                                <td>
                                  <Field
                                    type="text"
                                    name="DERContactPhone"
                                    id="DERContactPhone"
                                    className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                    component={renderField}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                    onChange={this._onChangeDerContactPhone}
                                  // onKeyDown={(evt) => ['e', 'E', '+', '-', '.']
                                  // .includes(evt.key) && evt.preventDefault()}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <th>Sales Rep</th>
                                <td>
                                  <Field
                                    type="text"
                                    name="DERRep"
                                    id="DERRep"
                                    className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                    component={renderField}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                    onChange={this._onChangeDerRep}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <th>Rep Phone</th>
                                <td>
                                  <Field
                                    type="text"
                                    name="DERRepPhone"
                                    id="DERRepPhone"
                                    className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                    component={renderField}
                                    onChange={this._onChangeDerRepPhone}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                    maxLength="25"
                                  // onKeyDown={(evt) => ['e', 'E', '+', '-', '.']
                                  // .includes(evt.key) && evt.preventDefault()}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <th>Territory</th>
                                <td>
                                  <Field
                                    type="text"
                                    name="DERTerritory"
                                    id="DERTerritory"
                                    className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                    component={renderField}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                    onChange={this._onChangeDerTerritory}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <th>Response Letter</th>
                                <td>
                                  <div className="p-0">
                                    <div className="form-check form-check-inline mb-0">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="ResponseLetter"
                                        id="responseLetterYes" value="YES"
                                        checked={addNewDers.ResponseLetter === 'YES'}
                                        onChange={() => this._onResponseLetter('YES')}
                                        disabled={isEditDer === false && viewDersDetails === true}
                                      />
                                      <label
                                        className="form-check-label cursor-pointer"
                                        htmlFor="responseLetterYes"
                                      >Yes
                                      </label>
                                    </div>
                                    <div className="form-check form-check-inline mb-0">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="ResponseLetter"
                                        id="responseLetterNo" value="NO"
                                        checked={addNewDers.ResponseLetter === 'NO'}
                                        onChange={() => this._onResponseLetter('NO')}
                                        disabled={isEditDer === false && viewDersDetails === true}
                                      />
                                      <label
                                        className="form-check-label cursor-pointer"
                                        htmlFor="responseLetterNo"
                                      >No
                                      </label>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <th>Response Recipient</th>
                                <td>
                                  <Field
                                    type="text"
                                    name="ResponseRecipient"
                                    className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                    component={renderField}
                                    onChange={this._onChangeResponseRecipient}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                </td>
                              </tr>
                            </table>
                          )
                        }
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item accordionItem" style={{ marginBottom: 4 }}>
                    <div className="accordion-header" id="headingTwo">
                      <button
                        className="accordion-button collapsed" type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo" aria-expanded="false"
                        aria-controls="collapseTwo"
                        id="hospitalCustomerComplainant"
                      >
                        Hospital / Customer Complainant
                      </button>
                      <button
                        type="button" className="btn btn-cross"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo" aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        <i
                          className="fa fa-times-circle"
                          onClick={isEditDer === false && viewDersDetails === true ? () => { } : () => this._onClearDersFormFields('hospital')}
                        />
                      </button>
                    </div>
                    <div
                      id="collapseTwo" className="accordion-collapse collapse"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#accordionDRE"
                    >
                      <div className="accordion-body">
                        <table className="table der-table table-dark table-bordered mb-0">
                          <tr>
                            <th>Surgeon Name</th>
                            <td>
                              <Field
                                type="text"
                                name="SurgeonName"
                                id="SurgeonName"
                                className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                component={renderField}
                                defaultValue={`${caseDer === 'true' && addNewDers.SurgeonName !== '' && addNewDers.SurgeonName}`}
                                onChange={this._onChangeSurgeonName}
                                disabled={isEditDer === false && viewDersDetails === true}
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>Customer Name</th>
                            <td>
                              <Field
                                type="text"
                                name="CustomerName"
                                id="CustomerName"
                                className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                component={renderField}
                                onChange={this._onChangeCustomerName}
                                disabled={isEditDer === false && viewDersDetails === true}
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>Customer No</th>
                            <td>
                              <Field
                                type="number"
                                name="CustomerNo"
                                id="CustomerNo"
                                className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                component={renderField}
                                onChange={this._onChangeCustomerNo}
                                disabled={isEditDer === false && viewDersDetails === true}
                                onKeyDown={(evt) => ['e', 'E', '+', '-', '.'].includes(evt.key) && evt.preventDefault()}
                              />
                            </td>
                          </tr>
                          <tr style={{ display: 'none' }}>
                            <th>Credit Invoice No</th>
                            <td>
                              <Field
                                type="text"
                                name="CreditInvoiceNo"
                                className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                component={renderField}
                                onChange={this._onChangeCreditInvoiceNo}
                                disabled={isEditDer === false && viewDersDetails === true}
                              />
                            </td>
                          </tr>
                          <tr style={{ display: 'none' }}>
                            <th>Credit Account No</th>
                            <td>
                              <Field
                                type="text"
                                name="CreditAccountNo"
                                className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                component={renderField}
                                onChange={this._onChangeCreditAccountNo}
                                disabled={isEditDer === false && viewDersDetails === true}
                              />
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item accordionItem" style={{ marginBottom: 4 }}>
                    <div className="accordion-header" id="headingThree">
                      <button
                        className="accordion-button collapsed" type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree" aria-expanded="false"
                        aria-controls="collapseThree"
                        id="eventDateInformation"
                      >
                        Event Date Information
                      </button>
                      <button
                        type="button" className="btn btn-cross"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree" aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        <i
                          className="fa fa-times-circle"
                          onClick={isEditDer === false && viewDersDetails === true ? () => { } : () => this._onClearDersFormFields('eventDate')}
                        />
                      </button>
                    </div>
                    <div
                      id="collapseThree" className="accordion-collapse collapse"
                      aria-labelledby="headingThree"
                      data-bs-parent="#accordionDRE"
                    >
                      <div className="accordion-body">
                        <table className="table der-table table-dark table-bordered mb-0">
                          <tr style={{ display: 'none' }}>
                            <th>Rep Present</th>
                            <td>
                              <div className="p-0">
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="RepPresent"
                                    id="repPresentYes" value="YES"
                                    checked={addNewDers.RepPresent === 'YES'}
                                    onChange={() => this._onRepPresent('YES')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="repPresentYes">Yes</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="RepPresent"
                                    id="repPresentNo" value="NO"
                                    checked={addNewDers.RepPresent === 'NO'}
                                    onChange={() => this._onRepPresent('NO')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="repPresentNo">No</label>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <th>Date Aware</th>
                            <td>
                              <OptimizeDatePicker
                                dateFormat="MM/dd/yyyy"
                                className="form-control date-picker-read-only"
                                id="date-picker-input"
                                name="DateAware"
                                selected={selectedDateAware}
                                onChange={(value) => {
                                  this.setState({ selectedDateAware: value });
                                }}
                                onChangeRaw={(e) => {
                                  e.preventDefault();
                                }}
                                disabled={isEditDer === false && viewDersDetails === true}
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>Date Implanted</th>
                            <td>
                              <OptimizeDatePicker
                                dateFormat="MM/dd/yyyy"
                                className="form-control date-picker-read-only"
                                id="date-picker-input1"
                                name="DateImplanted"
                                selected={selectedDateImplanted}
                                onChange={(value) => {
                                  this.setState({ selectedDateImplanted: value });
                                }}
                                onChangeRaw={(e) => {
                                  e.preventDefault();
                                }}
                                disabled={isEditDer === false && viewDersDetails === true}
                              />
                            </td>
                          </tr>
                          <tr style={{ display: 'none' }}>
                            <th>Same Hospital Where Implanted</th>
                            <td>
                              <div className="p-0">
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="PrimaryCustomerSame"
                                    id="primaryCustomerSameYes" value="YES"
                                    checked={addNewDers.PrimaryCustomerSame === 'YES'}
                                    onChange={() => this._onPrimaryCustomerSame('YES')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="primaryCustomerSameYes">Yes</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="PrimaryCustomerSame"
                                    id="primaryCustomerSameNo" value="NO"
                                    checked={addNewDers.PrimaryCustomerSame === 'NO'}
                                    onChange={() => this._onPrimaryCustomerSame('NO')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="primaryCustomerSameNo">No</label>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr style={{ display: 'none' }}>
                            <th>Hospital Where Implanted</th>
                            <td>
                              <Field
                                type="text"
                                name="PrimaryCustomer"
                                id="PrimaryCustomer"
                                className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                component={renderField}
                                onChange={this._onChangePrimaryCustomer}
                                disabled={isEditDer === false && viewDersDetails === true}
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>Date Explanted / Event Date</th>
                            <td>
                              <OptimizeDatePicker
                                dateFormat="MM/dd/yyyy"
                                className="form-control date-picker-read-only"
                                id="date-picker-input2"
                                name="DateExplanted"
                                selected={selectedDateExplanted}
                                onChange={(value) => {
                                  this.setState({ selectedDateExplanted: value });
                                }}
                                onChangeRaw={(e) => {
                                  e.preventDefault();
                                }}
                                disabled={isEditDer === false && viewDersDetails === true}
                              />
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item accordionItem" style={{ marginBottom: 4 }}>
                    <div className="accordion-header" id="headingFour">
                      <button
                        className="accordion-button collapsed" type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFour" aria-expanded="false"
                        aria-controls="collapseFour"
                        id="patientInformation"
                      >
                        Patient Information
                      </button>
                      <button
                        type="button" className="btn btn-cross"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFour" aria-expanded="false"
                        aria-controls="collapseFour"
                      >
                        <i
                          className="fa fa-times-circle"
                          onClick={isEditDer === false && viewDersDetails === true ? () => { } : () => this._onClearDersFormFields('patient')}
                        />
                      </button>
                    </div>
                    <div
                      id="collapseFour" className="accordion-collapse collapse"
                      aria-labelledby="headingFour"
                      data-bs-parent="#accordionDRE"
                    >
                      <div className="accordion-body">
                        <table className="table der-table table-dark table-bordered mb-0">
                          <tr>
                            <th>Patient Initials</th>
                            <td>
                              <Field
                                type="text"
                                name="PatientName"
                                id="PatientName"
                                className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                component={renderField}
                                onChange={this._onChangePatientName}
                                disabled={isEditDer === false && viewDersDetails === true}
                                onKeyDown={(evt) => ['\'', '%', '#', '*'].includes(evt.key) && evt.preventDefault()}
                                maxLength={50}
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>Age</th>
                            <td>
                              <Field
                                type="text"
                                name="PatientAge"
                                id="PatientAge"
                                className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                component={renderField}
                                // validate={[maxLength3, maxValue120]}
                                onChange={this._onChangePatientAge}
                                disabled={isEditDer === false && viewDersDetails === true}
                                maxLength="25"
                              // onKeyDown={(evt) => ['e', 'E', '+', '-', '.']
                              // .includes(evt.key) && evt.preventDefault()}
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>DOB</th>
                            <td>
                              <OptimizeDatePicker
                                dateFormat="MM/dd/yyyy"
                                className="form-control date-picker-read-only"
                                id="date-picker-input3"
                                name="PatientDOB"
                                selected={patientDob}
                                onChange={(value) => {
                                  this.setState({ patientDob: value });
                                }}
                                onChangeRaw={(e) => {
                                  e.preventDefault();
                                }}
                                disabled={isEditDer === false && viewDersDetails === true}
                                startYear="150"
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>Gender</th>
                            <td>
                              <div className="p-0">
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="PatientGender"
                                    id="patientGenderMale" value="MALE"
                                    checked={addNewDers.PatientGender === 'MALE'}
                                    onChange={() => this._onPatientGender('MALE')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="patientGenderMale">Male</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="PatientGender"
                                    id="patientGenderFemale" value="FEMALE"
                                    checked={addNewDers.PatientGender === 'FEMALE'}
                                    onChange={() => this._onPatientGender('FEMALE')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="patientGenderFemale">Female</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="PatientGender"
                                    id="patientGenderNo" value="UNKNOWN"
                                    checked={addNewDers.PatientGender === 'UNKNOWN'}
                                    onChange={() => this._onPatientGender('UNKNOWN')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label v" htmlFor="patientGenderNo">Unknown</label>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <th>Height</th>
                            <td>
                              <Field
                                type="text"
                                name="PatientHeight"
                                id="PatientHeight"
                                className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                component={renderField}
                                // validate={maxLength25}
                                onChange={this._onChangePatientHeight}
                                disabled={isEditDer === false && viewDersDetails === true}
                                maxLength="10"
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>Height Units</th>
                            <td>
                              <div className="p-0">
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="PatientHeightUnits"
                                    id="patientHeightUnitesFT" value="FT"
                                    checked={addNewDers.PatientHeightUnits === 'FT'}
                                    onChange={() => this._onPatientHeightUnits('FT')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="patientHeightUnitesFT">FT</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="PatientHeightUnits"
                                    id="patientHeightUnitesIN" value="IN"
                                    checked={addNewDers.PatientHeightUnits === 'IN'}
                                    onChange={() => this._onPatientHeightUnits('IN')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="patientHeightUnitesIN">IN</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="PatientHeightUnits"
                                    id="patientHeightUnitesCM" value="CM"
                                    checked={addNewDers.PatientHeightUnits === 'CM'}
                                    onChange={() => this._onPatientHeightUnits('CM')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="patientHeightUnitesCM">CM</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="PatientHeightUnits"
                                    id="patientHeightUnitesUnknown" value="UNKNOWN"
                                    checked={addNewDers.PatientHeightUnits === 'UNKNOWN'}
                                    onChange={() => this._onPatientHeightUnits('UNKNOWN')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="patientHeightUnitesUnknown">Unknown</label>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <th>Weight</th>
                            <td>
                              <Field
                                type="text"
                                name="PatientWeight"
                                id="PatientWeight"
                                className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                component={renderField}
                                // validate={maxLength25}
                                onChange={this._onChangePatientWeight}
                                disabled={isEditDer === false && viewDersDetails === true}
                                maxLength="10"
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>Weight Units</th>
                            <td>
                              <div className="p-0">
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="PatientWeightUnits"
                                    id="patientWeightUnitesLBS" value="LBS"
                                    checked={addNewDers.PatientWeightUnits === 'LBS'}
                                    onChange={() => this._onPatientWeightUnits('LBS')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="patientWeightUnitesLBS">LBS</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="PatientWeightUnits"
                                    id="patientWeightUnitesKG" value="KG"
                                    checked={addNewDers.PatientWeightUnits === 'KG'}
                                    onChange={() => this._onPatientWeightUnits('KG')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="patientWeightUnitesKG">KG</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="PatientWeightUnits"
                                    id="patientWeightUnitesUnknown" value="UNKNOWN"
                                    checked={addNewDers.PatientWeightUnits === 'UNKNOWN'}
                                    onChange={() => this._onPatientWeightUnits('UNKNOWN')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="patientWeightUnitesUnknown">Unknown</label>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <th>Clinical Study</th>
                            <td>
                              <div className="p-0">
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="PatientStudy"
                                    id="patientStudyYes" value="YES"
                                    checked={addNewDers.PatientStudy === 'YES'}
                                    onChange={() => this._onPatientStudy('YES')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="patientStudyYes">Yes</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="PatientStudy"
                                    id="patientStudyNo" value="NO"
                                    checked={addNewDers.PatientStudy === 'NO'}
                                    onChange={() => this._onPatientStudy('NO')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="patientStudyNo">No</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="PatientStudy"
                                    id="patientStudyUnknown" value="UNKNOWN"
                                    checked={addNewDers.PatientStudy === 'UNKNOWN'}
                                    onChange={() => this._onPatientStudy('UNKNOWN')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="patientStudyUnknown">Unknown</label>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr style={{ display: 'none' }}>
                            <th>Clinical ID</th>
                            <td>
                              <Field
                                type="text"
                                name="PatientClinicalID"
                                className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                component={renderField}
                                onChange={this._onChangePatientClinicalID}
                                disabled={isEditDer === false && viewDersDetails === true}
                              />
                            </td>
                          </tr>
                          <tr style={{ display: 'none' }}>
                            <th>Activity Level</th>
                            <td>
                              <Select2
                                style={{ width: '100%', color: 'red' }}
                                className={`form-control select2-hidden-accessible ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                name="PatientActivity"
                                data={patientActivity.map((activityRes) => (
                                  activityRes))}
                                onChange={({ target: { value } }) => {
                                  this.setState({ selectedActivity: value });
                                }}
                                value={selectedActivity}
                                disabled={isEditDer === false && viewDersDetails === true}
                              />
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item accordionItem" style={{ marginBottom: 4 }}>
                    <div className="accordion-header" id="headingFive">
                      <button
                        className="accordion-button collapsed" type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFive" aria-expanded="false"
                        aria-controls="collapseFive"
                        id="eventInformation"
                      >
                        Event Information
                      </button>
                      <button
                        type="button" className="btn btn-cross"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFive" aria-expanded="false"
                        aria-controls="collapseFive"
                      >
                        <i
                          className="fa fa-times-circle"
                          onClick={isEditDer === false && viewDersDetails === true ? () => { } : () => this._onClearDersFormFields('event')}
                        />
                      </button>
                    </div>
                    <div
                      id="collapseFive" className="accordion-collapse collapse"
                      aria-labelledby="headingFive"
                      data-bs-parent="#accordionDRE"
                    >
                      <div className="accordion-body">
                        <table className="table der-table table-dark table-bordered mb-0">
                          <tr>
                            <th>Event Info</th>
                            <p className={`ms-1 ${isMobile ? '' : 'uc-first-letter'}`}>
                              <textarea
                                id="eventInfo"
                                name="EventInfo"
                                value={addNewDers.EventInfo}
                                className={`form-control uc-first-letter ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                autoCapitalize="on"
                                onChange={(event) => this._onChangeEventInfo('EventInfo', window.UCFirst(event.target.value))}
                                disabled={isEditDer === false && viewDersDetails === true}
                              />
                            </p>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item accordionItem" style={{ marginBottom: 4 }}>
                    <div className="accordion-header" id="headingSix">
                      <button
                        className="accordion-button collapsed" type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSix" aria-expanded="false"
                        aria-controls="collapseSix"
                        id="additionalEventInformation"
                      >
                        Additional Event Information
                      </button>
                      <button
                        type="button" className="btn btn-cross"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSix" aria-expanded="false"
                        aria-controls="collapseSix"
                      >
                        <i
                          className="fa fa-times-circle"
                          onClick={isEditDer === false && viewDersDetails === true ? () => { } : () => this._onClearDersFormFields('additionalEvent')}
                        />
                      </button>
                    </div>
                    <div
                      id="collapseSix" className="accordion-collapse collapse"
                      aria-labelledby="headingSix"
                      data-bs-parent="#accordionDRE"
                    >
                      <div className="accordion-body">
                        <table className="table der-table table-dark table-bordered mb-0">
                          <tr style={{ display: 'none' }}>
                            <th>X-rays Available</th>
                            <td>
                              <div className="p-0">
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="XraysAvailable"
                                    id="xraysAvailableYes" value="YES"
                                    checked={addNewDers.XraysAvailable === 'YES'}
                                    onChange={() => this._onXraysAvailable('YES')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="xraysAvailableYes">Yes</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="XraysAvailable"
                                    id="xraysAvailableNo" value="NO"
                                    checked={addNewDers.XraysAvailable === 'NO'}
                                    onChange={() => this._onXraysAvailable('NO')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="xraysAvailableNo">No</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="XraysAvailable"
                                    id="xraysAvailableUnknown" value="UNKNOWN"
                                    checked={addNewDers.XraysAvailable === 'UNKNOWN'}
                                    onChange={() => this._onXraysAvailable('UNKNOWN')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="xraysAvailableUnknown">Unknown</label>
                                </div>
                              </div>
                            </td>
                          </tr>
                          {
                            addNewDers.XraysAvailable === 'NO'
                            && (
                              <tr style={{ display: 'none' }}>
                                <th>X-rays Reason</th>
                                <td>
                                  <Field
                                    type="text"
                                    name="XraysAvailableReason"
                                    className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                    component={renderField}
                                    onChange={this._onChangeXraysAvailableReason}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                </td>
                              </tr>
                            )
                          }
                          <tr>
                            <th>Loosening</th>
                            <td>
                              <div className="p-0">
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="Loosening"
                                    id="looseningYes" value="YES"
                                    checked={addNewDers.Loosening === 'YES'}
                                    onChange={() => this._onLooseing('YES')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="looseningYes">Yes</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="Loosening"
                                    id="looseningNo" value="NO"
                                    checked={addNewDers.Loosening === 'NO'}
                                    onChange={() => this._onLooseing('NO')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="looseningNo">No</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="Loosening"
                                    id="looseningUnknown" value="UNKNOWN"
                                    checked={addNewDers.Loosening === 'UNKNOWN'}
                                    onChange={() => this._onLooseing('UNKNOWN')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="looseningUnknown">Unknown</label>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <th>Loosening Components</th>
                            <td>
                              <Field
                                type="text"
                                name="LooseningComponents"
                                id="LooseningComponents"
                                className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                component={renderField}
                                onChange={this._onChangeLooseningComponents}
                                disabled={isEditDer === false && viewDersDetails === true}
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>Loosening Interface</th>
                            <td>
                              <div className="p-0">
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="LooseningInterface"
                                    id="looseningInterfaceBoneCement" value="BONE/CEMENT"
                                    checked={addNewDers.LooseningInterface === 'BONE/CEMENT'}
                                    onChange={() => this._onLooseningInterface('BONE/CEMENT')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="looseningInterfaceBoneCement">Bone/Cement</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="LooseningInterface"
                                    id="looseningInterfaceCementImplant" value="CEMENT/IMPLANT"
                                    checked={addNewDers.LooseningInterface === 'CEMENT/IMPLANT'}
                                    onChange={() => this._onLooseningInterface('CEMENT/IMPLANT')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="looseningInterfaceCementImplant">Cement/Implant</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="LooseningInterface"
                                    id="looseningInterfaceNonCemented" value="NON-CEMENTED"
                                    checked={addNewDers.LooseningInterface === 'NON-CEMENTED'}
                                    onChange={() => this._onLooseningInterface('NON-CEMENTED')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="looseningInterfaceNonCemented">Non-cemented</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="LooseningInterface"
                                    id="looseningInterfaceNonApplicable" value="NON-APPLICABLE"
                                    checked={addNewDers.LooseningInterface === 'NON-APPLICABLE'}
                                    onChange={() => this._onLooseningInterface('NON-APPLICABLE')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="looseningInterfaceNonApplicable">Non Applicable</label>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <th>Cement MFR</th>
                            <td>
                              <div className="p-0">
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="CementMFR"
                                    id="cementMFRDePuySynthes" value="DEPUY SYNTHES"
                                    checked={addNewDers.CementMFR === 'DEPUY SYNTHES'}
                                    onChange={() => this._onCementMfr('DEPUY SYNTHES')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="cementMFRDePuySynthes">DePuy Synthes</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="CementMFR"
                                    id="cementMFRCompetitor" value="COMPETITOR"
                                    checked={addNewDers.CementMFR === 'COMPETITOR'}
                                    onChange={() => this._onCementMfr('COMPETITOR')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="cementMFRCompetitor">Competitor</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="CementMFR"
                                    id="cementMFRUnknown" value="UNKNOWN"
                                    checked={addNewDers.CementMFR === 'UNKNOWN'}
                                    onChange={() => this._onCementMfr('UNKNOWN')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="cementMFRUnknown">Unknown</label>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr style={{ display: 'none' }}>
                            <th>Product Deficiency</th>
                            <td>
                              <div className="p-0">
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="ProductDeficiency"
                                    id="ProductDeficiencyYes" value="YES"
                                    checked={addNewDers.ProductDeficiency === 'YES'}
                                    onChange={() => this._onProductDeficiency('YES')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="ProductDeficiencyYes">Yes</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="ProductDeficiency"
                                    id="ProductDeficiencyNo" value="NO"
                                    checked={addNewDers.ProductDeficiency === 'NO'}
                                    onChange={() => this._onProductDeficiency('NO')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="ProductDeficiencyNo">No</label>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <th>All Broken Pieces Retrieved</th>
                            <td>
                              <div className="p-0">
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="BrokenRemoved"
                                    id="brokenRemovedYes" value="YES"
                                    checked={addNewDers.BrokenRemoved === 'YES'}
                                    onChange={() => this._onBrokenRemoved('YES')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="brokenRemovedYes">Yes</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="BrokenRemoved"
                                    id="brokenRemovedNo" value="NO"
                                    checked={addNewDers.BrokenRemoved === 'NO'}
                                    onChange={() => this._onBrokenRemoved('NO')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="brokenRemovedNo">No</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="BrokenRemoved"
                                    id="brokenRemovedNotApplicable" value="NA"
                                    checked={addNewDers.BrokenRemoved === 'NA'}
                                    onChange={() => this._onBrokenRemoved('NA')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="brokenRemovedNo">Not Applicable</label>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr style={{ display: 'none' }}>
                            <th>Surgery Extended</th>
                            <td>
                              <div className="p-0">
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="SurgeryExtend"
                                    id="surgeryExtendYes" value="YES"
                                    checked={addNewDers.SurgeryExtend === 'YES'}
                                    onChange={() => this._onSurgeryExtend('YES')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="surgeryExtendYes">Yes</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="SurgeryExtend"
                                    id="surgeryExtendNo" value="NO"
                                    checked={addNewDers.SurgeryExtend === 'NO'}
                                    onChange={() => this._onSurgeryExtend('NO')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="surgeryExtendNo">No</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="SurgeryExtend"
                                    id="surgeryExtendUnknown" value="UNKNOWN"
                                    checked={addNewDers.SurgeryExtend === 'UNKNOWN'}
                                    onChange={() => this._onSurgeryExtend('UNKNOWN')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="surgeryExtendUnknown">Unknown</label>
                                </div>
                              </div>
                            </td>
                          </tr>
                          {
                            addNewDers.SurgeryExtend === 'YES'
                            && (
                              <tr style={{ display: 'none' }}>
                                <th>Surgery Extend Time</th>
                                <td>
                                  <Field
                                    type="number"
                                    name="SurgeryExtendTime"
                                    className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                    component={renderField}
                                    onChange={this._onChangeSurgeryExtendTime}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                    onKeyDown={(evt) => ['e', 'E', '+', '-', '.'].includes(evt.key) && evt.preventDefault()}
                                  />
                                </td>
                              </tr>
                            )
                          }
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item accordionItem" style={{ marginBottom: 4 }}>
                    <div className="accordion-header" id="headingSeven">
                      <button
                        className="accordion-button collapsed" type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSeven" aria-expanded="false"
                        aria-controls="collapseSeven"
                        id="productBrokenInformation"
                      >
                        Products / Broken Instruments
                      </button>
                      {/* <button type="button" className="btn btn-plus">
                        <i
                          className="fa fa-plus"
                           onClick={isEditDer === false && viewDersDetails === true
                            ? () => {} : () => this._onClickAddProduct()}
                        />
                      </button> */}
                      <button
                        type="button" className="btn btn-cross"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSeven" aria-expanded="false"
                        aria-controls="collapseSeven"
                      >
                        <i
                          className="fa fa-times-circle"
                          onClick={isEditDer === false && viewDersDetails === true ? () => { } : () => this._onClearDersFormFields('products')}
                        />
                      </button>
                    </div>
                    <div
                      id="collapseSeven" className="accordion-collapse collapse"
                      aria-labelledby="headingSeven"
                      data-bs-parent="#accordionDRE"
                    >
                      {
                        ProductsBroken.length && ProductsBroken.map((item, key) => (
                          <div className="accordion-body" key={key}>
                            <table className="table der-table table-dark table-bordered mb-0">
                              <tr>
                                <th>Code / Desc</th>
                                <td>
                                  <Field
                                    type="text"
                                    name={`ProductCode${key}`}
                                    id={`ProductCode${key}`}
                                    className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                    component={renderField}
                                    onChange={(e) => this._onChangeProductCode(e, key)}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <th>Lot</th>
                                <td>
                                  <Field
                                    type="text"
                                    name={`ProductLot${key}`}
                                    id={`ProductLot${key}`}
                                    className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                    component={renderField}
                                    onChange={(e) => this._onChangeProductLot(e, key)}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                    maxLength={25}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <th>Side</th>
                                <td>
                                  <div className="p-0">
                                    <div className="form-check form-check-inline mb-0">
                                      <input
                                        className="form-check-input" type="radio"
                                        name={`ProductSide${key}`}
                                        id={`productSideLeft${key}`}
                                        value="LEFT"
                                        checked={item.ProductSide === 'LEFT'}
                                        onChange={() => this._onProductSide('LEFT', key)}
                                        disabled={isEditDer === false && viewDersDetails === true}
                                      />
                                      <label className="form-check-label cursor-pointer" htmlFor="productSideLeft">Left</label>
                                    </div>
                                    <div className="form-check form-check-inline mb-0">
                                      <input
                                        className="form-check-input" type="radio"
                                        name={`ProductSide${key}`}
                                        id={`productSideRight${key}`}
                                        value="RIGHT"
                                        checked={item.ProductSide === 'RIGHT'}
                                        onChange={() => this._onProductSide('RIGHT', key)}
                                        disabled={isEditDer === false && viewDersDetails === true}
                                      />
                                      <label className="form-check-label cursor-pointer" htmlFor="productSideRight">Right</label>
                                    </div>
                                    <div className="form-check form-check-inline mb-0">
                                      <input
                                        className="form-check-input" type="radio"
                                        name={`ProductSide${key}`}
                                        id={`productSideUnknown${key}`}
                                        value="UNKNOWN"
                                        checked={item.ProductSide === 'UNKNOWN'}
                                        onChange={() => this._onProductSide('UNKNOWN', key)}
                                        disabled={isEditDer === false && viewDersDetails === true}
                                      />
                                      <label className="form-check-label cursor-pointer" htmlFor="productSideUnknown">Unknown</label>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <th>Used</th>
                                <td>
                                  <div className="p-0">
                                    <div className="form-check form-check-inline mb-0">
                                      <input
                                        className="form-check-input" type="radio"
                                        name={`ProductUsed${key}`}
                                        id={`ProductUsedYes${key}`}
                                        value="YES"
                                        checked={item.ProductUsed === 'YES'}
                                        onChange={() => this._onProductUsed('YES', key)}
                                        disabled={isEditDer === false && viewDersDetails === true}
                                      />
                                      <label className="form-check-label cursor-pointer" htmlFor="productUsedYes">Yes</label>
                                    </div>
                                    <div className="form-check form-check-inline mb-0">
                                      <input
                                        className="form-check-input" type="radio"
                                        name={`ProductUsed${key}`}
                                        id={`ProductUsedNo${key}`}
                                        value="NO"
                                        checked={item.ProductUsed === 'NO'}
                                        onChange={() => this._onProductUsed('NO', key)}
                                        disabled={isEditDer === false && viewDersDetails === true}
                                      />
                                      <label className="form-check-label cursor-pointer" htmlFor="productUsedNo">No</label>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <th>Being returned</th>
                                <td>
                                  <div className="p-0">
                                    <div className="form-check form-check-inline mb-0">
                                      <input
                                        className="form-check-input" type="radio"
                                        name={`ProductedReturned${key}`}
                                        id={`ProductedReturnedYes${key}`}
                                        value="YES"
                                        checked={item.ProductedReturned === 'YES'}
                                        onChange={() => this._onProductReturned('YES', key)}
                                        disabled={isEditDer === false && viewDersDetails === true}
                                      />
                                      <label className="form-check-label cursor-pointer" htmlFor="productReturnedYes">Yes</label>
                                    </div>
                                    <div className="form-check form-check-inline mb-0">
                                      <input
                                        className="form-check-input" type="radio"
                                        name={`ProductedReturned${key}`}
                                        id={`ProductedReturnedNo${key}`}
                                        value="NO"
                                        checked={item.ProductedReturned === 'NO'}
                                        onChange={() => this._onProductReturned('NO', key)}
                                        disabled={isEditDer === false && viewDersDetails === true}
                                      />
                                      <label className="form-check-label cursor-pointer" htmlFor="productReturnedNo">No</label>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <th>Qty</th>
                                <td>
                                  <Field
                                    type="number"
                                    name={`ProductQty${key}`}
                                    id={`ProductQty${key}`}
                                    className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                    component={renderField}
                                    onChange={(e) => this._onChangeProductQty(e, key)}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                    onKeyDown={(evt) => ['e', 'E', '+', '-', '.'].includes(evt.key) && evt.preventDefault()}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <th style={{ border: 'none' }}>
                                  <td style={{ border: 'none' }}>
                                    {ProductsBroken.length - 1 === key && 'Up to 20 products can be entered.'}
                                  </td>
                                </th>
                              </tr>
                            </table>
                          </div>
                        ))
                      }
                    </div>
                  </div>
                  <div className="accordion-item accordionItem" style={{ marginBottom: 4, display: 'none' }}>
                    <div className="accordion-header" id="headingEight">
                      <button
                        className="accordion-button collapsed" type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseEight" aria-expanded="false"
                        aria-controls="collapseEight"
                      >
                        Investigation Inputs
                      </button>
                      <button
                        type="button" className="btn btn-cross"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseEight" aria-expanded="false"
                        aria-controls="collapseEight"
                      >
                        <i
                          className="fa fa-times-circle"
                          onClick={isEditDer === false && viewDersDetails === true ? () => { } : () => this._onClearDersFormFields('investigation')}
                        />
                      </button>
                    </div>
                    <div
                      id="collapseEight" className="accordion-collapse collapse"
                      aria-labelledby="headingEight"
                      data-bs-parent="#accordionDRE"
                    >
                      <div className="accordion-body">
                        <table className="table der-table table-dark table-bordered mb-0">
                          <tr>
                            <th>Requestor</th>
                            <td>
                              <Field
                                type="text"
                                name="InvestigationRequestor"
                                className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                component={renderField}
                                onChange={this._onChangeInvestigationRequestor}
                                disabled={isEditDer === false && viewDersDetails === true}
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>Request Date</th>
                            <DatePicker
                              dateFormat="MM/dd/yyyy"
                              className="form-control date-picker-read-only"
                              id="date-picker-input4"
                              name="InvestigationDate"
                              selected={investigationDate}
                              onChange={(value) => {
                                this.setState({ investigationDate: value });
                              }}
                              onChangeRaw={(e) => {
                                e.preventDefault();
                              }}
                              disabled={isEditDer === false && viewDersDetails === true}
                            />
                          </tr>
                          <tr>
                            <th>Responder</th>
                            <td>
                              <Field
                                type="text"
                                name="InvestigationResponder"
                                className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                component={renderField}
                                onChange={this._onChangeInvestigationResponder}
                                disabled={isEditDer === false && viewDersDetails === true}
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>Responder Title</th>
                            <td>
                              <Field
                                type="text"
                                name="InvestigationResponderTitle"
                                className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                component={renderField}
                                onChange={this._onChangeInvestigationResponderTitle}
                                disabled={isEditDer === false && viewDersDetails === true}
                              />
                            </td>
                          </tr>
                          <tr>
                            <th>X-ray</th>
                            <td>
                              <div className="p-0">
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="Xray"
                                    id="xrayAvailable" value="1"
                                    checked={addNewDers.Xray === '1'}
                                    onChange={() => this._onXray('1')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="xrayAvailable">Available</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="Xray"
                                    id="xrayNotAvailable" value="0"
                                    checked={addNewDers.Xray === '0'}
                                    onChange={() => this._onXray('0')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="xrayNotAvailable">Not Available</label>
                                </div>
                              </div>
                            </td>
                          </tr>
                          {
                            addNewDers.Xray === '0'
                            && (
                              <tr>
                                <th style={{ paddingLeft: '20px' }}>Reason</th>
                                <td>
                                  <Field
                                    type="text"
                                    name="XrayReason"
                                    className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                    component={renderField}
                                    onChange={this._onChangeXrayReason}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                </td>
                              </tr>
                            )
                          }
                          <tr>
                            <th>Patient</th>
                            <td>
                              <div className="p-0">
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="Patient"
                                    id="PatientAvailable" value="1"
                                    checked={addNewDers.Patient === '1'}
                                    onChange={() => this._onPatient('1')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="PatientAvailable">Available</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="Patient"
                                    id="PatientNotAvailable" value="0"
                                    checked={addNewDers.Patient === '0'}
                                    onChange={() => this._onPatient('0')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="PatientNotAvailable">Not Available</label>
                                </div>
                              </div>
                            </td>
                          </tr>
                          {
                            addNewDers.Patient === '0'
                            && (
                              <tr>
                                <th style={{ paddingLeft: '20px' }}>Reason</th>
                                <td>
                                  <Field
                                    type="text"
                                    name="PatientReason"
                                    className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                    component={renderField}
                                    onChange={this._onChangePatientReason}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                </td>
                              </tr>
                            )
                          }
                          <tr>
                            <th>Blood</th>
                            <td>
                              <div className="p-0">
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="Blood"
                                    id="bloodAvailable" value="1"
                                    checked={addNewDers.Blood === '1'}
                                    onChange={() => this._onBlood('1')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="bloodAvailable">Available</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="Blood"
                                    id="bloodNotAvailable" value="0"
                                    checked={addNewDers.Blood === '0'}
                                    onChange={() => this._onBlood('0')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="bloodNotAvailable">Not Available</label>
                                </div>
                              </div>
                            </td>
                          </tr>
                          {
                            addNewDers.Blood === '0'
                            && (
                              <tr>
                                <th style={{ paddingLeft: '20px' }}>Reason</th>
                                <td>
                                  <Field
                                    type="text"
                                    name="BloodReason"
                                    className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                    component={renderField}
                                    onChange={this._onChangeBloodReason}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                </td>
                              </tr>
                            )
                          }
                          <tr>
                            <th>Histology</th>
                            <td>
                              <div className="p-0">
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="Histology"
                                    id="histologyAvailable" value="1"
                                    checked={addNewDers.Histology === '1'}
                                    onChange={() => this._onHistology('1')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="histologyAvailable">Available</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="Histology"
                                    id="histologyNotAvailable" value="0"
                                    checked={addNewDers.Histology === '0'}
                                    onChange={() => this._onHistology('0')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="histologyNotAvailable">Not Available</label>
                                </div>
                              </div>
                            </td>
                          </tr>
                          {
                            addNewDers.Histology === '0'
                            && (
                              <tr>
                                <th style={{ paddingLeft: '20px' }}>Reason</th>
                                <td>
                                  <Field
                                    type="text"
                                    name="HistologyReason"
                                    className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                    component={renderField}
                                    onChange={this._onChangeHistologyReason}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                </td>
                              </tr>
                            )
                          }
                          <tr>
                            <th>MRI</th>
                            <td>
                              <div className="p-0">
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="MRI"
                                    id="MRIAvailable" value="1"
                                    checked={addNewDers.MRI === '1'}
                                    onChange={() => this._onMri('1')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="MRIAvailable">Available</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="MRI"
                                    id="MRINotAvailable" value="0"
                                    checked={addNewDers.MRI === '0'}
                                    onChange={() => this._onMri('0')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="MRINotAvailable">Not Available</label>
                                </div>
                              </div>
                            </td>
                          </tr>
                          {
                            addNewDers.MRI === '0'
                            && (
                              <tr>
                                <th style={{ paddingLeft: '20px' }}>Reason</th>
                                <td>
                                  <Field
                                    type="text"
                                    name="MRIReason"
                                    className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                    component={renderField}
                                    onChange={this._onChangeMriReason}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                </td>
                              </tr>
                            )
                          }
                          <tr>
                            <th>Ultrasound</th>
                            <td>
                              <div className="p-0">
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="Ultrasound"
                                    id="ultrasoundAvailable" value="1"
                                    checked={addNewDers.Ultrasound === '1'}
                                    onChange={() => this._onUltraSound('1')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="ultrasoundAvailable">Available</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="Ultrasound"
                                    id="ultrasoundNotAvailable" value="0"
                                    checked={addNewDers.Ultrasound === '0'}
                                    onChange={() => this._onUltraSound('0')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="ultrasoundNotAvailable">Not Available</label>
                                </div>
                              </div>
                            </td>
                          </tr>
                          {addNewDers.Ultrasound === '0'
                            && (
                              <tr>
                                <th style={{ paddingLeft: '20px' }}>Reason</th>
                                <td>
                                  <Field
                                    type="text"
                                    name="UltraSoundReason"
                                    className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                    component={renderField}
                                    onChange={this._onChangeUltraSoundReason}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                </td>
                              </tr>
                            )}
                          <tr>
                            <th>Clinical</th>
                            <td>
                              <div className="p-0">
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="Clinical"
                                    id="clinicalAvailable" value="1"
                                    checked={addNewDers.Clinical === '1'}
                                    onChange={() => this._onClinical('1')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="clinicalAvailable">Available</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="Clinical"
                                    id="clinicalNotAvailable" value="0"
                                    checked={addNewDers.Clinical === '0'}
                                    onChange={() => this._onClinical('0')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="clinicalNotAvailable">Not Available</label>
                                </div>
                              </div>
                            </td>
                          </tr>
                          {
                            addNewDers.Clinical === '0'
                            && (
                              <tr>
                                <th style={{ paddingLeft: '20px' }}>Reason</th>
                                <td>
                                  <Field
                                    type="text"
                                    name="ClinicalReason"
                                    className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                    component={renderField}
                                    onChange={this._onChangeClinicalReason}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                </td>
                              </tr>
                            )
                          }
                          <tr>
                            <th>Primary</th>
                            <td>
                              <div className="p-0">
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="Primary"
                                    id="primaryAvailable" value="1"
                                    checked={addNewDers.Primary === '1'}
                                    onChange={() => this._onPrimary('1')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="primaryAvailable">Available</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="Primary"
                                    id="primaryNotAvailable" value="0"
                                    checked={addNewDers.Primary === '0'}
                                    onChange={() => this._onPrimary('0')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="primaryNotAvailable">Not Available</label>
                                </div>
                              </div>
                            </td>
                          </tr>
                          {
                            addNewDers.Primary === '0'
                            && (
                              <tr>
                                <th style={{ paddingLeft: '20px' }}>Reason</th>
                                <td>
                                  <Field
                                    type="text"
                                    name="PrimaryReason"
                                    className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                    component={renderField}
                                    onChange={this._onChangePrimaryReason}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                </td>
                              </tr>
                            )
                          }
                          <tr>
                            <th>Revision</th>
                            <td>
                              <div className="p-0">
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="Revision"
                                    id="revisionAvailable" value="1"
                                    checked={addNewDers.Revision === '1'}
                                    onChange={() => this._onRevision('1')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="revisionAvailable">Available</label>
                                </div>
                                <div className="form-check form-check-inline mb-0">
                                  <input
                                    className="form-check-input" type="radio"
                                    name="Revision"
                                    id="revisionNotAvailable" value="0"
                                    checked={addNewDers.Revision === '0'}
                                    onChange={() => this._onRevision('0')}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                  <label className="form-check-label cursor-pointer" htmlFor="revisionNotAvailable">Not Available</label>
                                </div>
                              </div>
                            </td>
                          </tr>
                          {
                            addNewDers.Revision === '0'
                            && (
                              <tr>
                                <th style={{ paddingLeft: '20px' }}>Reason</th>
                                <td>
                                  <Field
                                    type="text"
                                    name="RevisionReason"
                                    className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                    component={renderField}
                                    onChange={this._onChangeRevisionReason}
                                    disabled={isEditDer === false && viewDersDetails === true}
                                  />
                                </td>
                              </tr>
                            )
                          }
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item accordionItem" style={{ marginBottom: 4 }}>
                    <div className="accordion-header" id="headingEight">
                      <button
                        className="accordion-button collapsed" type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseNine" aria-expanded="false"
                        aria-controls="collapseNine"
                      >
                        DER Email Notes
                      </button>
                      <button
                        type="button" className="btn btn-cross"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseNine" aria-expanded="false"
                        aria-controls="collapseNine"
                      >
                        <i
                          className="fa fa-times-circle"
                          onClick={isEditDer === false && viewDersDetails === true ? () => { } : () => this._onClearDersFormFields('derEmailNotes')}
                        />
                      </button>
                    </div>
                    <div
                      id="collapseNine" className="accordion-collapse collapse"
                      aria-labelledby="headingEight"
                      data-bs-parent="#accordionDRE"
                    >
                      <div className="accordion-body">
                        <table className="table der-table table-dark table-bordered mb-0">
                          <tr>
                            <th>DER notes (only visible in email body)</th>
                            <td>
                              <Field
                                type="textarea"
                                name="DERNotes"
                                className={`form-control ${(isEditDer === false && viewDersDetails === true) ? 'addDer-disabled' : ''}`}
                                component={renderField}
                                onChange={this._onChangeDerNotes}
                                disabled={isEditDer === false && viewDersDetails === true}
                              />
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <DerNotSaved
            onClickYes={this._onClickYes}
          />
        </section>
        <div className="fixed-bottom der-footer-section resizer-class">
          <div className="container">
            <div className="row gx-2">
              {(isShowButtons.isCreate || isShowButtons.isEdit || isShowButtons.isCopy) && (
                <div className="col-4">
                  <button
                    onClick={handleSubmit((values) => this._onSubmitDers({
                      ...values,
                      isSave: true
                    }))}
                    className="btn btn-theme-alt btn-theme-outline-alt d-block w-100"
                  >Save
                  </button>
                </div>
              )}
              {isShowButtons.isSaved && (
                <div className="col-4">
                  <button
                    className="btn btn-theme-alt btn-theme-outline-alt d-block w-100" style={{ color: 'green' }}
                    disabled
                  >Saved
                  </button>
                </div>
              )}
              {
                (isShowButtons.isCreate || isShowButtons.isEdit) && <div className="col-4" />
              }
              {
                (isShowButtons.isView && !isShowButtons.isSaved) && <div className="col-4" />
              }
              {(isShowButtons.isView) && (
                <div className="col-4">
                  <button
                    type="button"
                    onClick={this._onCopyDer}
                    className="btn btn-theme-alt btn-theme-outline-alt d-block w-100"
                  >Copy
                  </button>
                </div>
              )}
              {isShowButtons.isCopy
                && (
                  <div className="col-4">
                    <p className="w-100 text-center editing-der"><span>Editing DER </span></p>
                  </div>
                )}
              {
                ((isShowButtons.isView && addNewDers.Submited === '0')
                  || isShowButtons.isEdit
                  || isShowButtons.isCreate
                  || isShowButtons.isCopy)
                && (
                  <div className="col-4">
                    <button
                      onClick={handleSubmit((values) => this._onSubmitDers({
                        ...values,
                        isSave: false
                      }))}
                      className="btn btn-theme-alt btn-theme-outline-alt d-block w-100"
                      disabled={isShowButtons.isCreate || isShowButtons.isCopy}
                    >Submit
                    </button>
                  </div>
                )
              }
              {
                (!isShowButtons.isSubmitted && addNewDers.Submited === '1')
                && (
                  <div className="col-4">
                    <button
                      className="btn btn-theme-alt btn-theme-outline-alt d-block w-100"
                      style={{ color: 'green' }}
                      disabled
                    >Submitted
                    </button>
                  </div>
                )
              }
            </div>
          </div>
        </div>
        <DerNotSaved />
        <DersErrorMessage
          message={errorMessage}
          onPressOkay={() => this.onPressOkay()}
        />
        <ClearDersFields
          onClear={this._onClickYesClear}
          value={clearForm}
        />
        <CopyDers derNo={copyDerNo} />
      </form>
    );
  }
}

const addDers = withSelectCaseId(
  withOnline(
    withGoBack(
      withNotify(
        withLoader(
          withTeam(
            withDersDetails(
              withIsShowButtons(
                withCaseDer(
                  withTableName(
                    withDersFilterResult(
                      withUser(
                        withDersProduct(
                          withViewDersDetails(
                            withReadCaseData(
                              AddNonCaseDer
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  )
);

export default compose(
  connect((state) => ({
    formData: state.form.AddDersForm
  })),
  reduxForm({ form: 'AddDersForm' })
)(addDers);
